
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gnpMO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4cOi8 = parcelRequire("4cOi8");

var $1Yx9c = parcelRequire("1Yx9c");

var $fOKpq = parcelRequire("fOKpq");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $069d581736ad089f$exports = {};

var $jr8iR = parcelRequire("jr8iR");


var $hRuRu = parcelRequire("hRuRu");


var $ehlgT = parcelRequire("ehlgT");

/** Used as references for various `Number` constants. */ var $069d581736ad089f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $069d581736ad089f$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $069d581736ad089f$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $069d581736ad089f$var$times(n, iteratee) {
    n = $ehlgT(n);
    if (n < 1 || n > $069d581736ad089f$var$MAX_SAFE_INTEGER) return [];
    var index = $069d581736ad089f$var$MAX_ARRAY_LENGTH, length = $069d581736ad089f$var$nativeMin(n, $069d581736ad089f$var$MAX_ARRAY_LENGTH);
    iteratee = $hRuRu(iteratee);
    n -= $069d581736ad089f$var$MAX_ARRAY_LENGTH;
    var result = $jr8iR(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
$069d581736ad089f$exports = $069d581736ad089f$var$times;



var $1Whri = parcelRequire("1Whri");


var $eyWa4 = parcelRequire("eyWa4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $8Yfbq = parcelRequire("8Yfbq");





var $gdv5Z = parcelRequire("gdv5Z");




var $4JDbp = parcelRequire("4JDbp");


var $IBZYB = parcelRequire("IBZYB");


var $lPcXt = parcelRequire("lPcXt");


var $ahPKE = parcelRequire("ahPKE");

const $cbc545f2775878ae$export$ba1fe8828f2c393e = 16;
const $cbc545f2775878ae$export$f4a9066d04eb34fe = 16;
const $cbc545f2775878ae$var$styles = {
    flexBox: "_1e0c1txw _kqswh2mm _19bvze3t",
    stacked: "_1n261g80",
    row: "_1reo15vq _18m915vq",
    left: "_1bah1y6m",
    center: "_1bah1h6o",
    right: "_1bahesu3"
};
const $cbc545f2775878ae$export$37f8d84bb48ae4b7 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, cardsContentFooter: CardsContentFooter, testId: testId })=>{
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $lPcXt.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(setCurrentCardsGridWidth, 200);
    const orientation = isStacked ? 'grid' : 'row';
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $IBZYB.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: cards?.length,
        isRow: !isStacked
    });
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                testId: `link-cards-content-cards-${orientation}`,
                xcss: (0, $1Whri.cx)($cbc545f2775878ae$var$styles.flexBox, isStacked ? $cbc545f2775878ae$var$styles.stacked : $cbc545f2775878ae$var$styles.row, /**
     * Align left regardless of alignment if
     * - orientation is row
     * - the grid width is smaller or equal to the minimum width of the card size
     */ !isStacked || isGridSmallerOrEqualWidthToCards ? $cbc545f2775878ae$var$styles.left : $cbc545f2775878ae$var$styles[alignment]),
                style: {
                    gap: `${spaceBetweenCards}px`
                },
                role: "list",
                children: [
                    cards.map((card, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ahPKE.CardOrientationWrapper), {
                            cardId: card.cardId,
                            isFirstRowFull: isFirstRowFull,
                            cardWidthOnFullRow: cardWidthOnFullRow,
                            itemDimensions: cardDimensions,
                            setWidth: index === 0 ? setCurrentCardWidth : undefined,
                            scrollToCard: index === scrollToIndex,
                            clearScrollToCard: resetScrollIndex,
                            testId: `link-cards-content-cards-${orientation}-card-${index}`,
                            index: index,
                            requestScrollIndex: requestScrollIndex,
                            extensionLocalId: extensionLocalId,
                            ariaRole: "listitem",
                            children: renderCard(card)
                        }, index)),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                        setWidth: throttledSetWidth,
                        offscreen: true
                    })
                ]
            }),
            cards.length > 0 && CardsContentFooter && /*#__PURE__*/ (0, $l998X.jsx)(CardsContentFooter, {
                isStacked: isStacked,
                showAIDisclaimer: showAIDisclaimer,
                allCardsShown: allCardsShown,
                isAtBeginning: isAtBeginning,
                isAtEnd: isAtEnd,
                scrollToPrevious: scrollToPrevious,
                scrollToNext: scrollToNext
            })
        ]
    });
};








var $aXWIB = parcelRequire("aXWIB");


var $a3fRD = parcelRequire("a3fRD");


var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");







const $244e38cc9236b946$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorLoadingCardsPreamble: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-preamble",
        defaultMessage: "We\u2019re having trouble loading these cards."
    },
    errorLoadingCardsSupport: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-support",
        defaultMessage: "Reload to try again."
    }
});


const $92f476fa60bd9f29$var$inlineStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $92f476fa60bd9f29$export$533cd3269e981a31 = ({ error: error })=>{
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    (0, $42omo.useEffect)(()=>{
        submitError?.(error);
    }, [
        error,
        submitError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $92f476fa60bd9f29$var$inlineStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                weight: "medium",
                size: "medium",
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $244e38cc9236b946$export$defe85febe8b728c).errorLoadingCardsPreamble
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                weight: "medium",
                size: "medium",
                color: "color.text.subtlest",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $244e38cc9236b946$export$defe85febe8b728c).errorLoadingCardsSupport
                })
            })
        ]
    });
};









const $ef7e4501b98ea11b$export$93c098ff84870fcb = ({ isCompanyHub: isCompanyHub, isSegmentationShown: isSegmentationShown, isTargetAudience: isTargetAudience, cards: cards, isInViewMode: isInViewMode, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant })=>{
    const shouldApplySegmentation = (0, $42omo.useMemo)(()=>isCompanyHub && isSegmentationShown, [
        isCompanyHub,
        isSegmentationShown
    ]);
    const filteredCards = (0, $42omo.useMemo)(()=>{
        const isAudienceSegmentationEnabled = isInViewMode && shouldApplySegmentation;
        const isDynamicOrManualWithAllTarget = renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC || renderVariant === (0, $4cOi8.RenderVariant).MANUAL && segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL;
        if (!isAudienceSegmentationEnabled) return cards;
        if (isDynamicOrManualWithAllTarget) return isTargetAudience(audienceSegmentationGroupIds) ? cards : [];
        return cards.filter((card)=>isTargetAudience(card.audienceSegmentationGroupIds));
    }, [
        isInViewMode,
        shouldApplySegmentation,
        segmentationTarget,
        cards,
        renderVariant,
        isTargetAudience,
        audienceSegmentationGroupIds
    ]);
    return {
        filteredCards: filteredCards
    };
};




const $18092cac9334e981$export$c6c5cac0793c45d9 = (items)=>{
    const itemIdSet = (0, $42omo.useMemo)(()=>new Set(items.map((item)=>item.cardId)), [
        items
    ]);
    const [areAllItemsLoaded, setAreAllItemsLoaded] = (0, $42omo.useState)(false);
    const [itemFailureError, setItemFailureError] = (0, $42omo.useState)(null);
    const onItemFailed = (0, $42omo.useCallback)((error)=>{
        setItemFailureError(error);
    }, []);
    const onItemSucceeded = (0, $42omo.useCallback)((itemId)=>{
        itemIdSet.delete(itemId);
        if (itemIdSet.size === 0) setAreAllItemsLoaded(true);
    }, [
        itemIdSet
    ]);
    return (0, $42omo.useMemo)(()=>({
            areAllItemsLoaded: areAllItemsLoaded,
            itemFailureError: itemFailureError,
            onItemSucceeded: onItemSucceeded,
            onItemFailed: onItemFailed
        }), [
        areAllItemsLoaded,
        itemFailureError,
        onItemSucceeded,
        onItemFailed
    ]);
};














var $7w8ah = parcelRequire("7w8ah");

var $iqWjJ = parcelRequire("iqWjJ");


var $gK4nz = parcelRequire("gK4nz");

var $glYzA = parcelRequire("glYzA");

var $4ERNs = parcelRequire("4ERNs");


var $33vwh = parcelRequire("33vwh");


var $e51Sk = parcelRequire("e51Sk");

const $8e24f0fc13788755$var$getFilterValue = (filter)=>{
    return filter?.split(',') || [];
};
const $8e24f0fc13788755$var$getFilterDateRange = (filters)=>{
    const { lastModified: lastModified } = filters;
    if (lastModified && lastModified !== 'custom') return [
        (0, $33vwh.getConfluenceDateOptionValues)(lastModified)
    ];
    else if (lastModified === 'custom') {
        if (filters?.from && filters?.to) return [
            (0, $33vwh.getConfluenceDateOptionFromCustomDates)(filters.from, filters.to)
        ];
    }
    return [];
};
const $8e24f0fc13788755$var$getEntities = (type)=>{
    if (type === 'page') return [
        (0, $gK4nz.PAGE_ATI)
    ];
    else if (type === 'blogpost') return [
        (0, $gK4nz.BLOGPOST_ATI)
    ];
    return [
        (0, $gK4nz.PAGE_ATI),
        (0, $gK4nz.BLOGPOST_ATI)
    ];
};
const $8e24f0fc13788755$var$getConfluenceFilters = (filters)=>{
    const { spaces: spaces, owners: owners, labels: labels, contributors: contributors, ancestor: ancestor, verified: verified } = filters;
    return {
        spacesFilter: $8e24f0fc13788755$var$getFilterValue(spaces),
        isVerified: verified || undefined,
        contributorsFilter: $8e24f0fc13788755$var$getFilterValue(contributors),
        ancestorIdsFilter: $8e24f0fc13788755$var$getFilterValue(ancestor),
        range: $8e24f0fc13788755$var$getFilterDateRange(filters),
        owners: $8e24f0fc13788755$var$getFilterValue(owners),
        labelsFilter: $8e24f0fc13788755$var$getFilterValue(labels)
    };
};
const $8e24f0fc13788755$var$getSearchPageQueryVariables = (cardCount, filters, cloudId, searchSessionId)=>{
    const entities = $8e24f0fc13788755$var$getEntities(filters.type);
    return {
        query: '',
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: cardCount,
        entities: entities,
        commonFilters: {},
        confluenceFilters: $8e24f0fc13788755$var$getConfluenceFilters(filters),
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        queryVersion: 1,
        searchSessionId: searchSessionId ?? '',
        sort: [
            {
                field: filters.sortField || (0, $4ERNs.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                order: filters.sortOrder || (0, $4ERNs.SORT_ORDER).DESC
            }
        ]
    };
};
const $8e24f0fc13788755$export$7bf81438544569b5 = ()=>{
    const { cloudId: cloudId, searchConfigProvider: searchConfigProvider } = (0, $fOKpq.useProductDependencies)();
    const { searchSessionId: searchSessionId } = searchConfigProvider || {};
    const getDynamicCards = (0, $42omo.useCallback)(async (cardCount, filters)=>{
        const variables = $8e24f0fc13788755$var$getSearchPageQueryVariables(cardCount, filters, cloudId, searchSessionId);
        const { data: data, errors: errors } = await (0, $glYzA.searchPageQuery)({
            variables: variables
        });
        const results = data?.search.results.edges.map((edge)=>edge.node) || [];
        if (results.length === 0 || errors) return {
            cards: [],
            errors: errors
        };
        const trimmedResults = results?.slice(0, Math.min(cardCount, results.length));
        const dynamicCards = trimmedResults?.map((result)=>{
            const { title: title, description: description, url: url, id: id, confluenceEntity: confluenceEntity } = result;
            const newCard = (0, $e51Sk.createNewCardWithDefaultParameters)();
            newCard.link = url;
            newCard.title = title;
            newCard.description = description;
            newCard.confluencePageId = id.split('/')[1];
            if (confluenceEntity) {
                const { subtype: subtype, properties: properties } = confluenceEntity;
                const isLivePage = subtype === 'live';
                let imageProperty;
                if (isLivePage) imageProperty = properties?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
                else {
                    imageProperty = properties?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).PUBLISHED);
                    if (!imageProperty) imageProperty = properties?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
                }
                let imageSrc = (0, $7w8ah.propertyToId)(imageProperty)?.value?.id;
                if (imageSrc && !(0, $iqWjJ.isUnsplashImage)(imageSrc)) imageSrc = `${newCard.confluencePageId}/${imageSrc}`;
                newCard.imageSrc = imageSrc;
            }
            return newCard;
        });
        return {
            cards: dynamicCards,
            errors: errors
        };
    }, [
        cloudId,
        searchSessionId
    ]);
    return (0, $42omo.useMemo)(()=>({
            getDynamicCards: getDynamicCards
        }), [
        getDynamicCards
    ]);
};


const $08734f16b0a13216$export$5fe928848609fec7 = (parameters)=>{
    const { cardCount: cardCount, filters: filters } = parameters;
    const [cards, setCards] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const { getDynamicCards: getDynamicCards } = (0, $8e24f0fc13788755$export$7bf81438544569b5)();
    (0, $42omo.useEffect)(()=>{
        if (!!cardCount && !!filters) getDynamicCards(cardCount, filters).then(({ cards: dynamicCards, errors: aggErrors })=>{
            if (aggErrors) setError(new Error(JSON.stringify(aggErrors)));
            setCards(dynamicCards);
        }).catch((err)=>{
            setError(err);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        getDynamicCards,
        cardCount,
        filters
    ]);
    return (0, $42omo.useMemo)(()=>({
            cards: cards,
            loading: loading,
            error: error
        }), [
        cards,
        loading,
        error
    ]);
};



var $1VNax = parcelRequire("1VNax");




var $5un3P = parcelRequire("5un3P");



const $7165bea3d0a8ca43$var$checkIsParameterValueValid = (parameter, expectedValues)=>{
    return expectedValues.includes(parameter) ? parameter : null;
};
const $7165bea3d0a8ca43$var$checkSize = (size)=>$7165bea3d0a8ca43$var$checkIsParameterValueValid(size, [
        (0, $4cOi8.Height).SMALL,
        (0, $4cOi8.Height).MEDIUM,
        (0, $4cOi8.Height).LARGE
    ]);
const $7165bea3d0a8ca43$var$checkLayout = (layout)=>$7165bea3d0a8ca43$var$checkIsParameterValueValid(layout, [
        (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT,
        (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    ]);
const $7165bea3d0a8ca43$export$9a666555160249c1 = (currentParameters)=>{
    const validatedCards = (0, $1VNax.checkItems)(currentParameters.cards);
    const validatedSize = $7165bea3d0a8ca43$var$checkSize(currentParameters.size);
    const validatedLayout = $7165bea3d0a8ca43$var$checkLayout(currentParameters.layout);
    const validatedRequiredParameters = {
        ...currentParameters,
        size: validatedSize || (0, $4cOi8.Height).MEDIUM,
        cards: validatedCards || [],
        layout: validatedLayout || (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    };
    const { orientation: orientation, alignment: alignment, isAutoscrollEnabled: isAutoscrollEnabled } = validatedRequiredParameters;
    return {
        ...validatedRequiredParameters,
        // if alignment is not available (cards created before alignment), default to center
        alignment: alignment ?? (0, $5un3P.Alignment).CENTER,
        // if orientation is not available (cards created before orientation), default to stacked
        orientation: orientation ?? (0, $5un3P.Orientation).STACKED,
        isAutoscrollEnabled: orientation === (0, $5un3P.Orientation).STACKED ? false : isAutoscrollEnabled,
        // if audience segmentation new format is enabled and params are outdated, use the first card's audience segmentation group ids
        audienceSegmentationGroupIds: currentParameters.segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL && currentParameters.audienceSegmentationGroupIds === undefined ? currentParameters.cards[0]?.audienceSegmentationGroupIds : currentParameters?.audienceSegmentationGroupIds
    };
};







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");








var $1qfLF = parcelRequire("1qfLF");


var $7YEWU = parcelRequire("7YEWU");


var $lOHzS = parcelRequire("lOHzS");




var $u9agA = parcelRequire("u9agA");










var $bGmGb = parcelRequire("bGmGb");




const $63428b374bc2c5f8$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    pause: {
        id: "company-hub.cards-extension.autoscroll-wrapper.pause",
        defaultMessage: "Pause"
    },
    play: {
        id: "company-hub.cards-extension.autoscroll-wrapper.play",
        defaultMessage: "Play"
    }
});


const $d1c18879ec5e414d$export$ba1fe8828f2c393e = 16;
const $d1c18879ec5e414d$export$f4a9066d04eb34fe = 16;
const $d1c18879ec5e414d$var$wrapperStyles = null;
const $d1c18879ec5e414d$var$pausedStyles = null;
const $d1c18879ec5e414d$var$scrollAnimation = null;
const $d1c18879ec5e414d$var$styles = {
    iconBackgroundStyles: "_2rko1rr0 _bfhk1bhr _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconPadding: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    cardsGroup: "_1e0c1txw",
    container: "_kqswh2mm"
};
const $d1c18879ec5e414d$var$unboundedStyles = {
    wrapperStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1rjcv77o _kqswh2mm"
};
const $d1c18879ec5e414d$var$animationStyles = null;
const $d1c18879ec5e414d$var$shortDuration = null;
const $d1c18879ec5e414d$var$mediumDuration = null;
const $d1c18879ec5e414d$var$longDuration = null;
const $d1c18879ec5e414d$export$ac70d6b7d7a09503 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, testId: testId })=>{
    // there are 2 ways to pause the autoscroll
    // 1. Hover over a card. Should resume back to speed when unhovered
    // 2. Pause button click. Should resume when clicked again. This is implemented to meet a11y standards
    const [isPaused, setIsPaused] = (0, $42omo.useState)(false);
    const handlePauseClick = ()=>setIsPaused(!isPaused);
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth } = (0, $lPcXt.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions
    });
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(setCurrentCardsGridWidth, 200);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowOverflown: isAnimationEnabled } = calculations;
    const renderCardsGroup = ()=>/*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        , {
            style: {
                gap: `${$d1c18879ec5e414d$export$ba1fe8828f2c393e}px`,
                paddingRight: `${$d1c18879ec5e414d$export$ba1fe8828f2c393e}px`
            },
            className: (0, $gMc0m.default)([
                $d1c18879ec5e414d$var$styles.cardsGroup,
                isAnimationEnabled && "",
                isAnimationEnabled && "_y44v543u _1bumglyw",
                numberOfCards <= 5 ? "_5sagx094" : numberOfCards <= 10 ? "_5sag1als" : "_5sag1bqb"
            ]),
            children: cards.map((card, cardIndex)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            minWidth: `${cardWidthOnFullRow}px`,
                            maxWidth: `${cardWidthOnFullRow}px`
                        },
                        className: (0, $gMc0m.default)([
                            $d1c18879ec5e414d$var$unboundedStyles.wrapperStyles
                        ]),
                        children: renderCard(card)
                    })
                }, cardIndex);
            })
        }); // we are making a duplicate call to renderCardsGroup to make the infinte scroll experience more seamless
    // duplicate call is only required when animation is enabled, meaning there is overflow of cards than the number of cards a row can fit
    // in which case, no autoscroll will take effect
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: testId,
        xcss: $d1c18879ec5e414d$var$styles.container,
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                "data-testid": "cards-autoscroll-wrapper",
                className: (0, $gMc0m.default)([
                    "_1reo15vq _1e0c1txw _1wudtrqk",
                    isPaused && "_10r1trqk"
                ]),
                children: [
                    renderCardsGroup(),
                    isAnimationEnabled && renderCardsGroup(),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                        setWidth: throttledSetWidth,
                        offscreen: true
                    })
                ]
            }),
            isAnimationEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignInline: "start",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $d1c18879ec5e414d$var$styles.iconPadding,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.075",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $d1c18879ec5e414d$var$styles.iconBackgroundStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    shape: "circle",
                                    icon: isPaused ? (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))) : (0, (/*@__PURE__*/$parcel$interopDefault($7YEWU))),
                                    label: isPaused ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $63428b374bc2c5f8$export$defe85febe8b728c).play
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $63428b374bc2c5f8$export$defe85febe8b728c).pause
                                    }),
                                    onClick: handlePauseClick
                                })
                            }),
                            showAIDisclaimer && /*#__PURE__*/ (0, $l998X.jsx)((0, $bGmGb.CardsAIDisclaimer), {})
                        ]
                    })
                })
            })
        ]
    });
};








const $7b58fd4258e6a026$export$efa81a508b70a345 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $7b58fd4258e6a026$export$f86a06fd1ecacb03 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 240,
        maxWidth: 294,
        height: 84
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        height: 320
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        height: 320
    }
};
const $7b58fd4258e6a026$export$6909d5bfaed761e6 = {
    [(0, $4cOi8.Height).SMALL]: {
        ...$7b58fd4258e6a026$export$f86a06fd1ecacb03[(0, $4cOi8.Height).SMALL]
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        minHeight: 52,
        maxHeight: 348
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        minHeight: 64,
        maxHeight: 424
    }
};


const $e41f25d61305a67d$export$90cc9ab68d35b5b9 = ({ cardSize: cardSize, layout: layout })=>{
    if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT) return (0, $7b58fd4258e6a026$export$6909d5bfaed761e6)[cardSize];
    // Default to flexible dimensions (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
    return (0, $7b58fd4258e6a026$export$f86a06fd1ecacb03)[cardSize];
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


















var $3LC7V = parcelRequire("3LC7V");

var $5TXU5 = parcelRequire("5TXU5");

var $8zS2j = parcelRequire("8zS2j");


var $9CM6e = parcelRequire("9CM6e");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $iXCQx = parcelRequire("iXCQx");


var $lhvsH = parcelRequire("lhvsH");

var $fQWPs = parcelRequire("fQWPs");




const $462fd57cdee18a3d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStatePlaceholderLabel: {
        id: "company-hub.company-hub-common.ui.empty-state.label-placeholder",
        defaultMessage: "LABEL"
    }
});


const $65b0289431fea6b1$var$styles = {
    label: "_2rkofajl _u5f31b66 _19bv1b66"
};
const $65b0289431fea6b1$export$bc1a48e1b7ed7af = ({ label: label, labelColor: labelColor })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const labelFinal = label || formatMessage((0, $462fd57cdee18a3d$export$defe85febe8b728c).emptyStatePlaceholderLabel);
    const labelColorFinal = labelColor ?? (0, $lhvsH.DEFAULT_GRAY_COLOR);
    const labelTextColorFinal = (0, $42omo.useMemo)(()=>{
        return (0, $fQWPs.isReadable)(labelColorFinal, "var(--ds-text, #292A2E)") ? 'color.text' : 'color.text.inverse';
    }, [
        labelColorFinal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            backgroundColor: labelColorFinal
        },
        className: (0, $gMc0m.default)([
            $65b0289431fea6b1$var$styles.label
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: labelTextColorFinal,
            size: "small",
            maxLines: 1,
            weight: "bold",
            children: labelFinal?.toUpperCase()
        })
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $6F6hl = parcelRequire("6F6hl");








var $fZitC = parcelRequire("fZitC");


var $1u5CA = parcelRequire("1u5CA");

const $3dfe810951ca69c6$var$DARK_THRESHOLD = 50;
const $3dfe810951ca69c6$var$convertToHoveredShade = (hexColor)=>{
    const lightnessPercentage = (0, $fZitC.getLightnessPercentage)(hexColor);
    if (lightnessPercentage === undefined) return hexColor;
    // Lighten dark colors; darken light colors slightly based on LCH lightness
    // 0 - 100 dark to light
    const LIGHTEN_TO = Math.min(100, Math.round(lightnessPercentage + 10));
    const DARKEN_TO = Math.max(0, Math.round(lightnessPercentage - 10));
    if (lightnessPercentage < $3dfe810951ca69c6$var$DARK_THRESHOLD) return (0, $fZitC.increaseLightness)(hexColor, LIGHTEN_TO);
    return (0, $fZitC.reduceLightness)(hexColor, DARKEN_TO);
};
const $3dfe810951ca69c6$export$8af9b0107e419002 = (backgroundColor)=>{
    const tokenizedHoveredBackgroundColor = (0, $1u5CA.getBackgroundHoveredColor)(backgroundColor);
    if (tokenizedHoveredBackgroundColor) return tokenizedHoveredBackgroundColor;
    const convertedColor = (0, $fQWPs.convertLegacyColor)(backgroundColor);
    if (convertedColor.isValid()) return $3dfe810951ca69c6$var$convertToHoveredShade(convertedColor.toHexString());
    return backgroundColor;
};


const $ef8b32455958df4d$export$1b6000962053a12c = (color)=>{
    const [backgroundColor, setBackgroundColor] = (0, $42omo.useState)();
    const [hoveredBackgroundColor, setHoveredBackgroundColor] = (0, $42omo.useState)();
    const [shownBackgroundColor, setShownBackgroundColor] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const hoveredBgColor = color ? (0, $3dfe810951ca69c6$export$8af9b0107e419002)(color) : undefined;
        setBackgroundColor(color);
        setShownBackgroundColor(color);
        setHoveredBackgroundColor(hoveredBgColor);
    }, [
        color
    ]);
    const handleHover = (0, $42omo.useCallback)(()=>{
        setShownBackgroundColor(hoveredBackgroundColor);
    }, [
        hoveredBackgroundColor
    ]);
    const handleUnhover = (0, $42omo.useCallback)(()=>{
        setShownBackgroundColor(backgroundColor);
    }, [
        backgroundColor
    ]);
    return {
        backgroundColor: shownBackgroundColor || backgroundColor,
        handleHover: handleHover,
        handleUnhover: handleUnhover
    };
};


var $19TyP = parcelRequire("19TyP");


var $g3LxX = parcelRequire("g3LxX");










const $d7ebe172edcc0fde$var$_default_1 = (0, $aXWIB.defineMessages)({
    selectToEditAriaLabel: {
        id: "company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label",
        defaultMessage: "Select card to edit"
    }
});
var $d7ebe172edcc0fde$export$2e2bcd8739ae039 = $d7ebe172edcc0fde$var$_default_1;


const $875e9f2f375ca359$var$unboundedStyles = {
    containerBase: "_1reo15vq _18m915vq _1dqonqa1 _189ee4h9 _1h6d1l7x _vchhusvi _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3i1osq _syazi7uo _bfhk1bhr",
    containerCorner: "_2rko1mok",
    viewOnHover: "_irr36o2t _d0altlke",
    overlayButtonForSelectToEdit: "_19itglyw _kqswstnw _b35bglyw _bfhk1j28 _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1pbykb7n",
    selectedToEdit: "_1a37dfik",
    selectedToRemove: "_1a3719ep _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _oounidpf _19woidpf _1g0vkb7n _154p105o _1rus1gly"
};
const $875e9f2f375ca359$var$SelectToEditButton = ({ cardId: cardId, extensionLocalId: extensionLocalId, onSelectStateUpdate: onSelectStateUpdate })=>{
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (cardId && extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(cardId);
        }
    }, [
        cardId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    (0, $42omo.useEffect)(()=>{
        onSelectStateUpdate?.({
            isSelectedToEdit: isSelectedToEdit,
            isSelectedToRemove: isSelectedToRemove
        });
    }, [
        isSelectedToEdit,
        isSelectedToRemove,
        onSelectStateUpdate
    ]); /*
                                                                   	Overlay an invisible button to allow click interaction on edit.
                                                                   	Also avoid violating A11y rules for making non-interactive element interactive by putting onClick on the container.
                                                                   */ 
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    return /*#__PURE__*/ (0, $l998X.jsx)("button", {
        onClick: handleClick,
        className: (0, $gMc0m.default)([
            $875e9f2f375ca359$var$unboundedStyles.overlayButtonForSelectToEdit
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $d7ebe172edcc0fde$export$2e2bcd8739ae039).selectToEditAriaLabel
            })
        })
    });
}; /**
    *
    * This component is used to wrap the card content and set the followings of the card
    * - border
    * - height (optional)
    * - background color
    * - hover effect ( for view)
    * - outline (for edit)
    * - color
    */ 
const $875e9f2f375ca359$export$8a23e74e5cf3ca41 = ({ id: id, cardHeight: cardHeight, isInViewMode: isInViewMode, children: children, hasLink: hasLink, cardId: cardId, extensionLocalId: extensionLocalId, cornerStyle: cornerStyle, backgroundColor: savedBackgroundColor, textColor: savedTextColor, borderColor: borderColor, isEditable: isEditable, isHoverable: isHoverable = true })=>{
    const isCardEditable = !isInViewMode && isEditable;
    const isCardHoverable = isInViewMode && hasLink && isHoverable;
    const [isSelectedToEdit, setIsSelectedToEdit] = (0, $42omo.useState)(false);
    const [isSelectedToRemove, setIsSelectedToRemove] = (0, $42omo.useState)(false); // handle theme responsiveness for text and background colors
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor, getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = (0, $42omo.useMemo)(()=>savedTextColor ? getDarkModeCompatibleTextColor(savedTextColor) : undefined, [
        savedTextColor,
        getDarkModeCompatibleTextColor
    ]);
    const backgroundColor = (0, $42omo.useMemo)(()=>savedBackgroundColor ? getDarkModeCompatibleBackgroundColor(savedBackgroundColor) : undefined, [
        savedBackgroundColor,
        getDarkModeCompatibleBackgroundColor
    ]);
    const { backgroundColor: currentBackgroundColor, handleHover: handleHover, handleUnhover: handleUnhover } = (0, $ef8b32455958df4d$export$1b6000962053a12c)(backgroundColor);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        handleHover();
    }, [
        handleHover
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        handleUnhover();
    }, [
        handleUnhover
    ]); // handle select to edit
    const handleSelectStateUpdate = (0, $42omo.useCallback)(({ isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove })=>{
        setIsSelectedToEdit(isSelectedToEdit);
        setIsSelectedToRemove(isSelectedToRemove);
    }, [
        setIsSelectedToEdit,
        setIsSelectedToRemove
    ]);
    const hideCorner = cornerStyle === (0, $4cOi8.CornerStyle).SQUARED;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": id,
        style: {
            height: cardHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: textColor,
            backgroundColor: currentBackgroundColor,
            borderColor: borderColor
        },
        ...isCardHoverable && !!savedBackgroundColor ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        } : {},
        className: (0, $gMc0m.default)([
            $875e9f2f375ca359$var$unboundedStyles.containerBase,
            !hideCorner && $875e9f2f375ca359$var$unboundedStyles.containerCorner,
            isCardHoverable && $875e9f2f375ca359$var$unboundedStyles.viewOnHover,
            isSelectedToEdit && $875e9f2f375ca359$var$unboundedStyles.selectedToEdit,
            isSelectedToRemove && $875e9f2f375ca359$var$unboundedStyles.selectedToRemove
        ]),
        children: [
            isCardEditable && /*#__PURE__*/ (0, $l998X.jsx)($875e9f2f375ca359$var$SelectToEditButton, {
                onSelectStateUpdate: handleSelectStateUpdate,
                cardId: cardId,
                extensionLocalId: extensionLocalId
            }),
            children
        ]
    });
};




var $aPwHF = parcelRequire("aPwHF");


var $jqjsu = parcelRequire("jqjsu");

var $evEMm = parcelRequire("evEMm");


var $hG3yD = parcelRequire("hG3yD");

const $4b55a0ace2d6aff2$var$hasValidUrl = (s)=>!!s && s.trim() !== '';
const $4b55a0ace2d6aff2$export$71956575015d1f5 = (link, imageData)=>{
    const loomThumbnailUrl = (0, $hG3yD.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $4b55a0ace2d6aff2$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $4b55a0ace2d6aff2$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? '';
    return '';
};





const $aeeaf0d423f7dea3$export$28a088c1679c6579 = ({ isOwnerInfoShown: isOwnerInfoShown, isModifiedOnShown: isModifiedOnShown, isSocialStatsShown: isSocialStatsShown })=>{
    // smart card elements render states
    const [isAvatarAvailable, setIsAvatarAvailable] = (0, $42omo.useState)();
    const [isOwnerNameAvailable, setIsOwnerNameAvailable] = (0, $42omo.useState)();
    const [isModifiedOnAvailable, setIsModifiedOnAvailable] = (0, $42omo.useState)();
    const [isCommentCountAvailable, setIsCommentCountAvailable] = (0, $42omo.useState)();
    const [isReactCountAvailable, setIsReactCountAvailable] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        // attempt to render the elements when they are supposed to be shown to get data availability
        setIsAvatarAvailable(!!isOwnerInfoShown);
        setIsOwnerNameAvailable(!!isOwnerInfoShown);
        setIsModifiedOnAvailable(!!isModifiedOnShown);
        setIsCommentCountAvailable(!!isSocialStatsShown);
        setIsReactCountAvailable(!!isSocialStatsShown);
    }, [
        isOwnerInfoShown,
        isModifiedOnShown,
        isSocialStatsShown
    ]);
    const shouldRenderOwnerInfo = (0, $42omo.useMemo)(()=>isAvatarAvailable || isOwnerNameAvailable, [
        isAvatarAvailable,
        isOwnerNameAvailable
    ]);
    const shouldRenderMetadata = (0, $42omo.useMemo)(()=>shouldRenderOwnerInfo || isModifiedOnAvailable, [
        shouldRenderOwnerInfo,
        isModifiedOnAvailable
    ]);
    const shouldRenderSocials = (0, $42omo.useMemo)(()=>isReactCountAvailable || isCommentCountAvailable, [
        isReactCountAvailable,
        isCommentCountAvailable
    ]);
    return {
        setIsAvatarAvailable: setIsAvatarAvailable,
        setIsOwnerNameAvailable: setIsOwnerNameAvailable,
        setIsModifiedOnAvailable: setIsModifiedOnAvailable,
        setIsReactCountAvailable: setIsReactCountAvailable,
        setIsCommentCountAvailable: setIsCommentCountAvailable,
        shouldRenderOwnerInfo: shouldRenderOwnerInfo,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    };
};





parcelRequire("42omo");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4wH3g = parcelRequire("4wH3g");


var $e0Oqq = parcelRequire("e0Oqq");


const $89b35c68973ec39a$export$836160481278e63f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vUDoI",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("5oWvd"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e0Oqq.EmojiPlaceholder), {
            ...props
        }) : null
});
const $89b35c68973ec39a$var$styles = {
    wrapper: "_1e0c1txw _1bah1h6o"
};
const $89b35c68973ec39a$export$56e4c85b6a8d02e6 = ({ emojiId: emojiId, height: height = 40, width: width = 40 })=>{
    const wrapper = (0, $42omo.useMemo)(()=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    maxWidth: `${width}px`
                },
                ...props,
                className: (0, $gMc0m.default)([
                    $89b35c68973ec39a$var$styles.wrapper
                ])
            }), [
        width
    ]);
    if (!emojiId) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($89b35c68973ec39a$export$836160481278e63f, {
        emoji: emojiId,
        height: height,
        wrapper: wrapper,
        renderResourcedEmoji: true
    });
};





var $k00oi = parcelRequire("k00oi");




const $9e2ac3240ff02a0e$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $9e2ac3240ff02a0e$export$6ed6867e3290476 = (link)=>{
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const [emojiId, setEmojiId] = (0, $42omo.useState)();
    const getEmoji = (0, $42omo.useCallback)(async ()=>{
        const client = new (0, $k00oi.default)();
        try {
            const queriedEmojiObject = await client.fetchData(link);
            setEmojiId($9e2ac3240ff02a0e$var$sanitizeEmojiValue(queriedEmojiObject.data['atlassian:titlePrefix']?.text));
        } catch (error) {
            submitError?.(error);
        }
    }, [
        link,
        submitError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!!link) getEmoji();
    }, [
        link,
        getEmoji
    ]);
    return {
        emojiId: !!emojiId ? emojiId : null
    };
};


const $e0e95a63d1499075$export$69387b41dfc808f7 = ({ link: link })=>{
    const { emojiId: emojiId } = (0, $9e2ac3240ff02a0e$export$6ed6867e3290476)(link);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.LinkIconElement), {
        iconTileSize: 24,
        render: emojiId ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $89b35c68973ec39a$export$56e4c85b6a8d02e6), {
                emojiId: emojiId,
                height: 24,
                width: 24
            }) : undefined
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $8b4757f8612ed1f0$export$6eeb615c261d1c6b = /*#__PURE__*/ function(FontVariant) {
    FontVariant["HeadingMedium"] = "headingMedium";
    FontVariant["HeadingSmall"] = "headingSmall";
    FontVariant["HeadingXSmall"] = "headingXSmall";
    FontVariant["Body"] = "body";
    FontVariant["BodyLarge"] = "bodyLarge";
    return FontVariant;
}({});
const $8b4757f8612ed1f0$var$unboundedStyles = {
    baseText: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _1yyj11wp",
    title: "_1bsb1osq",
    description: "_o5724jg8",
    headingMedium: "_11c81af2",
    headingSmall: "_11c81e3o",
    headingXSmall: "_11c81qyo",
    bodyLarge: "_11c81d4k",
    body: "_11c8fhey"
};
const $8b4757f8612ed1f0$export$474db65c3c394e1c = ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $gMc0m.default)([
            $8b4757f8612ed1f0$var$unboundedStyles.baseText,
            $8b4757f8612ed1f0$var$unboundedStyles.title,
            $8b4757f8612ed1f0$var$unboundedStyles[fontVariant]
        ]),
        children: children
    });
const $8b4757f8612ed1f0$export$16e0ed4cb97c00d4 = ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $gMc0m.default)([
            $8b4757f8612ed1f0$var$unboundedStyles.baseText,
            $8b4757f8612ed1f0$var$unboundedStyles.description,
            $8b4757f8612ed1f0$var$unboundedStyles[fontVariant]
        ]),
        children: children
    });





const $00743a112f1453da$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $b85a19d2e323979a$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pk1lpd _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky1d4k _mavj1kw7",
    smartCardWrapper: "_4t3i1osq _wht71osq"
};
const $b85a19d2e323979a$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    imageCorner: "_2rko1mok",
    imageWithPadding: "_1reo15vq _18m915vq _4t3imgvx",
    imageNoPadding: "_1reo15vq _18m915vq _4t3iuuw1 _19pkmgjw _2hwxmgjw _18u0mgjw _n3td1b66",
    headerWithImagePadding: "_ca0qu2gc _19bvu2gc",
    headerWithImage: "_1e0c1txw _kqswstnw _154ipxbi _1ltvpxbi",
    unresolvedAction: "_1reo15vq _18m915vq _11c81d4k _1bsb1osq _1bto1l2s _syazazsu",
    static: "_kqswpfqs",
    relative: "_kqswh2mm"
};
const $b85a19d2e323979a$var$MIN_TITLE_LINES = 3;
const $b85a19d2e323979a$var$MAX_TITLE_LINES = 5;
const $b85a19d2e323979a$var$MIN_DESCRIPTION_LINES = 3;
const $b85a19d2e323979a$var$MAX_DESCRIPTION_LINES = 6;
const $b85a19d2e323979a$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $b85a19d2e323979a$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $b85a19d2e323979a$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 2;
        descriptionMaxLine += 3;
    }
    if (titleMaxLine > $b85a19d2e323979a$var$MAX_TITLE_LINES) titleMaxLine = $b85a19d2e323979a$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $b85a19d2e323979a$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $b85a19d2e323979a$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $b85a19d2e323979a$export$a59c193ce67944a7 = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $4cOi8.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $4b55a0ace2d6aff2$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $b85a19d2e323979a$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title
        }, "title"),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $b85a19d2e323979a$var$styles.unresolvedAction,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $b85a19d2e323979a$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title || formatMessage((0, $00743a112f1453da$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "large-card-v2-content",
        xcss: (0, $1Whri.cx)($b85a19d2e323979a$var$styles.content, hasLink ? $b85a19d2e323979a$var$styles.static : $b85a19d2e323979a$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            spread: "space-between",
            space: "space.200",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.200",
                    children: [
                        hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)(isPaddingEnabled ? $b85a19d2e323979a$var$styles.imageWithPadding : $b85a19d2e323979a$var$styles.imageNoPadding, !hideCorner && isPaddingEnabled && $b85a19d2e323979a$var$styles.imageCorner),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                                contentId: contentId,
                                imageSrc: displayImageSrc,
                                imageAlt: imageAltText,
                                shouldShowExternalSiteImage: hasLink
                            })
                        }),
                        (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            xcss: (0, $1Whri.cx)(hasImage && $b85a19d2e323979a$var$styles.headerWithImage, hasImage && isPaddingEnabled && $b85a19d2e323979a$var$styles.headerWithImagePadding),
                            children: [
                                isIconShown && hasLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                                    link: link
                                }),
                                isLabelShown && !isLabelHidden && /*#__PURE__*/ (0, $l998X.jsx)((0, $65b0289431fea6b1$export$bc1a48e1b7ed7af), {
                                    label: label,
                                    labelColor: labelColor
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            testId: "large-card-body",
                            space: "space.100",
                            children: cardBodyItems
                        })
                    ]
                }),
                hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.050",
                            separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: "\u2022"
                            }),
                            alignBlock: "center",
                            children: [
                                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    space: "space.050",
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                            className: (0, $gMc0m.default)([
                                                $b85a19d2e323979a$var$unboundedStyles.avatar
                                            ]),
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                                onRender: setIsAvatarAvailable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByElement), {
                                            color: "inherit",
                                            hideFormat: true,
                                            onRender: setIsOwnerNameAvailable
                                        })
                                    ]
                                }),
                                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                                    color: "inherit",
                                    hideDatePrefix: true,
                                    onRender: setIsModifiedOnAvailable
                                })
                            ]
                        }),
                        shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                                    color: "inherit",
                                    onRender: setIsReactCountAvailable
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                                    color: "inherit",
                                    onRender: setIsCommentCountAvailable
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "large-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $b85a19d2e323979a$var$unboundedStyles.smartCardWrapper
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).Large,
                    removeBlockRestriction: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    enableSnippetRenderer: enableSnippetRenderer
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: cardContent
            })
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










































const $8cd68a7a628e8835$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $13e5f254f9926788$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky1d4k _mavj1kw7"
};
const $13e5f254f9926788$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq",
    floatingIcon: "_1reoewfl _18m9ewfl _bozgpxbi _154ixmi2 _4t3iidpf _kqswh2mm",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    socials: "_19pk1wug",
    unresolvedAction: "_1reo15vq _18m915vq _11c81d4k _1bsb1osq _1bto1l2s _syazazsu"
};
const $13e5f254f9926788$var$MIN_TITLE_LINES = 2;
const $13e5f254f9926788$var$MAX_TITLE_LINES = 4;
const $13e5f254f9926788$var$MIN_DESCRIPTION_LINES = 3;
const $13e5f254f9926788$var$MAX_DESCRIPTION_LINES = 6;
const $13e5f254f9926788$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $13e5f254f9926788$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $13e5f254f9926788$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 1;
        if (!shouldRenderMetadata) {
            titleMaxLine += 1;
            descriptionMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $13e5f254f9926788$var$MAX_TITLE_LINES) titleMaxLine = $13e5f254f9926788$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $13e5f254f9926788$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $13e5f254f9926788$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $13e5f254f9926788$export$299421c7aa71f32d = ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, description: description, showDescription: showDescription, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, extensionLocalId: extensionLocalId, isManualVariant: isManualVariant, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, enableSnippetRenderer: enableSnippetRenderer })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $4b55a0ace2d6aff2$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $13e5f254f9926788$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
            link: link
        }, "link-icon"),
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title
        }, "title"),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.unresolvedAction),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "large-card-v1-metadata",
            space: "space.050",
            separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "\u2022"
            }),
            alignBlock: "center",
            children: [
                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $13e5f254f9926788$var$unboundedStyles.avatar
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                onRender: setIsAvatarAvailable
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByElement), {
                            color: "inherit",
                            hideFormat: true,
                            onRender: setIsOwnerNameAvailable
                        })
                    ]
                }),
                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                    color: "inherit",
                    onRender: (hasData)=>setIsModifiedOnAvailable(hasData)
                })
            ]
        }, "metadata"),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $13e5f254f9926788$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description"),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "large-card-v1-socials",
            space: "space.150",
            xcss: $13e5f254f9926788$var$styles.socials,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                    color: "inherit",
                    onRender: setIsReactCountAvailable
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                    color: "inherit",
                    onRender: setIsCommentCountAvailable
                })
            ]
        }, "socials")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title || formatMessage((0, $8cd68a7a628e8835$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "large-card-content",
        xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.content),
        style: {
            height: cardHeight
        },
        children: [
            hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.image),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                    contentId: contentId,
                    imageSrc: displayImageSrc,
                    imageAlt: imageAltText,
                    shouldShowExternalSiteImage: hasLink
                })
            }),
            isIconShown && hasLink && hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.floatingIcon),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                    link: link
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: "large-card-body",
                space: "space.100",
                grow: "fill",
                xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.body),
                children: cardBodyItems
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "large-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $5TXU5.SmartLinkSize).XLarge,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError,
            children: cardContent
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");












































const $18ab0b696710a1d9$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $10bd7f32a1f45b52$var$unboundedStyles = {
    avatar: "_c71l1tcg _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fkyfhey _mavj1kw7",
    smartCardWrapper: "_4t3i1osq _wht71osq"
};
const $10bd7f32a1f45b52$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    imageCorner: "_2rko1mok",
    imageWithPadding: "_1reo15vq _18m915vq _4t3iautk",
    imageNoPadding: "_1reo15vq _18m915vq _4t3i11ux _19pkmgjw _2hwxmgjw _18u0mgjw",
    headerWithImagePadding: "_ca0qu2gc _19bvu2gc",
    headerWithImage: "_1e0c1txw _kqswstnw _154ipxbi _1ltvpxbi",
    unresolvedAction: "_1reo15vq _18m915vq _11c8fhey _1bsb1osq _1bto1l2s _syazazsu",
    static: "_kqswpfqs",
    relative: "_kqswh2mm"
};
const $10bd7f32a1f45b52$var$MIN_TITLE_LINES = 3;
const $10bd7f32a1f45b52$var$MIN_DESCRIPTION_LINES = 3;
const $10bd7f32a1f45b52$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $10bd7f32a1f45b52$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $10bd7f32a1f45b52$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 2;
    }
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $10bd7f32a1f45b52$export$b38e9910221b4e7e = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $4cOi8.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $4b55a0ace2d6aff2$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $10bd7f32a1f45b52$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title
        }, "title"),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $10bd7f32a1f45b52$var$styles.unresolvedAction,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Description
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $10bd7f32a1f45b52$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title || formatMessage((0, $18ab0b696710a1d9$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "medium-card-v2-content",
        xcss: (0, $1Whri.cx)($10bd7f32a1f45b52$var$styles.content, hasLink ? $10bd7f32a1f45b52$var$styles.static : $10bd7f32a1f45b52$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            spread: "space-between",
            space: "space.150",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)(isPaddingEnabled ? $10bd7f32a1f45b52$var$styles.imageWithPadding : $10bd7f32a1f45b52$var$styles.imageNoPadding, !hideCorner && isPaddingEnabled && $10bd7f32a1f45b52$var$styles.imageCorner),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                                contentId: contentId,
                                imageSrc: displayImageSrc,
                                imageAlt: imageAltText,
                                shouldShowExternalSiteImage: hasLink
                            })
                        }),
                        (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            xcss: (0, $1Whri.cx)(hasImage && $10bd7f32a1f45b52$var$styles.headerWithImage, hasImage && isPaddingEnabled && $10bd7f32a1f45b52$var$styles.headerWithImagePadding),
                            children: [
                                isIconShown && hasLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                                    link: link
                                }),
                                isLabelShown && !isLabelHidden && /*#__PURE__*/ (0, $l998X.jsx)((0, $65b0289431fea6b1$export$bc1a48e1b7ed7af), {
                                    label: label,
                                    labelColor: labelColor
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            testId: "medium-card-body",
                            space: "space.100",
                            children: cardBodyItems
                        })
                    ]
                }),
                hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.050",
                            alignBlock: "center",
                            children: [
                                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    className: (0, $gMc0m.default)([
                                        $10bd7f32a1f45b52$var$unboundedStyles.avatar
                                    ]),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                        onRender: setIsAvatarAvailable
                                    })
                                }),
                                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                                    color: "inherit",
                                    hideDatePrefix: true,
                                    onRender: setIsModifiedOnAvailable
                                })
                            ]
                        }),
                        shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                                    color: "inherit",
                                    onRender: setIsReactCountAvailable
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                                    color: "inherit",
                                    onRender: setIsCommentCountAvailable
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "medium-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $10bd7f32a1f45b52$var$unboundedStyles.smartCardWrapper
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).Medium,
                    removeBlockRestriction: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    enableSnippetRenderer: enableSnippetRenderer
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: cardContent
            })
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










































const $5944223131a8f0ac$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $39e9dc6831e8ee6a$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fkyfhey _mavj1kw7"
};
const $39e9dc6831e8ee6a$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq",
    floatingIcon: "_1reoewfl _18m9ewfl _bozgpxbi _154ixmi2 _4t3iidpf _kqswh2mm",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    socials: "_19pk1wug",
    unresolvedAction: "_1reo15vq _18m915vq _11c8fhey _1bsb1osq _1bto1l2s _syazazsu"
};
const $39e9dc6831e8ee6a$var$MIN_TITLE_LINES = 2;
const $39e9dc6831e8ee6a$var$MAX_TITLE_LINES = 5;
const $39e9dc6831e8ee6a$var$MIN_DESCRIPTION_LINES = 3;
const $39e9dc6831e8ee6a$var$MAX_DESCRIPTION_LINES = 7;
const $39e9dc6831e8ee6a$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $39e9dc6831e8ee6a$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $39e9dc6831e8ee6a$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        descriptionMaxLine += 2;
        titleMaxLine += 2;
        if (!shouldRenderMetadata) {
            descriptionMaxLine += 1;
            titleMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $39e9dc6831e8ee6a$var$MAX_TITLE_LINES) titleMaxLine = $39e9dc6831e8ee6a$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $39e9dc6831e8ee6a$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $39e9dc6831e8ee6a$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $39e9dc6831e8ee6a$export$42440eb4dfc95ce7 = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, showDescription: showDescription, enableSnippetRenderer: enableSnippetRenderer, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $4b55a0ace2d6aff2$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $39e9dc6831e8ee6a$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
            link: link
        }, "link-icon"),
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title
        }, "title"),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.unresolvedAction),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "medium-card-v1-metadata",
            space: "space.050",
            separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "\u2022"
            }),
            alignBlock: "center",
            children: [
                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $39e9dc6831e8ee6a$var$unboundedStyles.avatar
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                onRender: setIsAvatarAvailable
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByElement), {
                            color: "inherit",
                            hideFormat: true,
                            onRender: setIsOwnerNameAvailable
                        })
                    ]
                }),
                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                    color: "inherit",
                    hideDatePrefix: true,
                    onRender: setIsModifiedOnAvailable
                })
            ]
        }, "metadata"),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $39e9dc6831e8ee6a$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description"),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "medium-card-v1-socials",
            space: "space.150",
            xcss: $39e9dc6831e8ee6a$var$styles.socials,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                    color: "inherit",
                    onRender: setIsReactCountAvailable
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                    color: "inherit",
                    onRender: setIsCommentCountAvailable
                })
            ]
        }, "socials")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title || formatMessage((0, $5944223131a8f0ac$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "medium-card-v1-content",
        xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.content),
        style: {
            height: cardHeight
        },
        children: [
            hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.image),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                    contentId: contentId,
                    imageSrc: displayImageSrc,
                    imageAlt: imageAltText,
                    shouldShowExternalSiteImage: hasLink
                })
            }),
            isIconShown && hasLink && hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.floatingIcon),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                    link: link
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: "medium-card-body",
                space: "space.100",
                grow: "fill",
                xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.body),
                children: cardBodyItems
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "medium-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $5TXU5.SmartLinkSize).Medium,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError,
            children: cardContent
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







































const $9ab81816b1253ab1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $a9e75a3820d58e12$var$unboundedStyles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvrv2br",
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf"
};
const $a9e75a3820d58e12$var$styles = {
    body: "_1reo15vq _18m915vq _ca0qu2gc _n3tdu2gc _4t3i1osq",
    bodyWithImage: "_16jlidpf _1o9zidpf _i0dl1wug _19bvu2gc _u5f3u2gc _p12fif8e _1e0c1txw",
    bodyWithoutImage: "_19bvpxbi _u5f3pxbi",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dli9or _4t3i1osq _p12fi9or _1e0c1txw",
    unresolvedAction: "_1reo15vq _18m915vq _11c8fhey _1bsb1osq _1bto1l2s _syazazsu"
};
const $a9e75a3820d58e12$export$5c35843a47cb7bc4 = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isInViewMode: isInViewMode, imageAltText: imageAltText, contentId: contentId, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const cardHeight = cardDimensions.height;
    const hasLink = !!link;
    const { errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess, isResolved: isResolved } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink
    });
    const displayImageSrc = (0, $4b55a0ace2d6aff2$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const cardBodyItem = hasLink ? [
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: shouldRenderMetadata ? 2 : 3,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingXSmall,
            children: title
        }, "title"),
        hasError && !title && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a9e75a3820d58e12$var$styles.unresolvedAction),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "small-card-v1-metadata",
            space: "space.050",
            alignBlock: "center",
            children: [
                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $a9e75a3820d58e12$var$unboundedStyles.avatar
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                        onRender: setIsAvatarAvailable
                    })
                }),
                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                    color: "inherit",
                    onRender: setIsModifiedOnAvailable
                })
            ]
        }, "metadata")
    ].filter(Boolean) : [
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: 3,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingXSmall,
            children: title || formatMessage((0, $9ab81816b1253ab1$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "small-card-content",
        style: {
            height: cardHeight
        },
        className: (0, $gMc0m.default)([
            $a9e75a3820d58e12$var$unboundedStyles.content
        ]),
        children: [
            hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($a9e75a3820d58e12$var$styles.image),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                    contentId: contentId,
                    imageSrc: displayImageSrc,
                    imageAlt: imageAltText,
                    shouldShowExternalSiteImage: hasLink
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: "small-card-body",
                space: "space.100",
                xcss: (0, $1Whri.cx)($a9e75a3820d58e12$var$styles.body, hasImage && $a9e75a3820d58e12$var$styles.bodyWithImage, !hasImage && $a9e75a3820d58e12$var$styles.bodyWithoutImage),
                alignBlock: "center",
                alignInline: "start",
                children: cardBodyItem
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "small-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $5TXU5.SmartLinkSize).Large,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError,
            children: cardContent
        }) : cardContent
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $gj7hi = parcelRequire("gj7hi");







var $8cb85d3c5a5090c3$exports = {};
$8cb85d3c5a5090c3$exports = new URL("General.d0402e27.svg", import.meta.url).toString();


var $g50oa = parcelRequire("g50oa");









const $f67cc898d7c2c834$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noResultsTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-results-title",
        defaultMessage: "Nothing yet. Check back soon."
    },
    noFilterTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-filter-title",
        defaultMessage: "Add filters to populate cards."
    }
});


const $eacc84e085bad39b$var$styles = {
    container: "_4t3i1osq",
    imageBase: "_bfhkysee",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    innerImageSmall: "_1bsb1wqb _4t3i1wqb _ca0q1b66 _u5f3u2gc _n3tdu2gc _19bv1b66",
    titleBase: "_11c8fhey _u5f3utpp _19bvutpp _ca0qutpp _n3tdutpp _syazi7uo",
    largeFont: "_11c81d4k",
    titleBlock: "_4t3ickbl",
    imageInline: "_1ul9ys9h _4t3i1osq",
    titleInline: "_4t3i1osq"
};
const $eacc84e085bad39b$var$SmallCard = ({ imageSrc: imageSrc, title: title })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        testId: "no-result-card-small",
        xcss: $eacc84e085bad39b$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.imageBase, $eacc84e085bad39b$var$styles.imageInline),
                children: imageSrc && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    alignBlock: "center",
                    alignInline: "center",
                    xcss: $eacc84e085bad39b$var$styles.innerImageSmall,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: imageSrc,
                        alt: "no-result",
                        testId: "no-result-image"
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.titleBase, $eacc84e085bad39b$var$styles.titleInline),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...title
                })
            })
        ]
    });
};
const $eacc84e085bad39b$var$MediumLargeCard = ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize = (0, $4cOi8.Height).MEDIUM, imageSrc: imageSrc, title: title })=>{
    const isLargeCard = cardSize === (0, $4cOi8.Height).LARGE;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: "no-result-card",
        space: "space.025",
        xcss: $eacc84e085bad39b$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.imageBase, isImageFixedHeight ? isLargeCard ? $eacc84e085bad39b$var$styles.imageFixedHeightLarge : $eacc84e085bad39b$var$styles.imageFixedHeightMedium : $eacc84e085bad39b$var$styles.imageFlexibleHeight),
                children: imageSrc && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: imageSrc,
                    alt: "no-result",
                    testId: "no-result-image"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.titleBase, $eacc84e085bad39b$var$styles.titleBlock, isLargeCard && $eacc84e085bad39b$var$styles.largeFont),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...title
                })
            })
        ]
    });
};
var $eacc84e085bad39b$export$fddf379e22a74b00 = /*#__PURE__*/ function(EmptyState) {
    EmptyState["NO_FILTER"] = "noFilter";
    EmptyState["NO_RESULTS"] = "noResults";
    return EmptyState;
}({});
const $eacc84e085bad39b$var$getStateContent = (state)=>{
    if (state === "noFilter") return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($g50oa))),
        title: (0, $f67cc898d7c2c834$export$defe85febe8b728c).noFilterTitle
    };
    return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($8cb85d3c5a5090c3$exports))),
        title: (0, $f67cc898d7c2c834$export$defe85febe8b728c).noResultsTitle
    };
};
const $eacc84e085bad39b$export$15b55049a5f7f585 = ({ cardSize: cardSize, layout: layout, cardDimensions: cardDimensions, state: state })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const { imageSrc: imageSrc, title: title } = $eacc84e085bad39b$var$getStateContent(state);
    if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $4cOi8.Height).SMALL) return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                minHeight: minHeight,
                maxHeight: maxHeight
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($eacc84e085bad39b$var$MediumLargeCard, {
                isImageFixedHeight: true,
                cardSize: cardSize,
                imageSrc: imageSrc,
                title: title
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        cardHeight: height,
        children: cardSize === (0, $4cOi8.Height).SMALL ? /*#__PURE__*/ (0, $l998X.jsx)($eacc84e085bad39b$var$SmallCard, {
            imageSrc: imageSrc,
            title: title
        }) : /*#__PURE__*/ (0, $l998X.jsx)($eacc84e085bad39b$var$MediumLargeCard, {
            imageSrc: imageSrc,
            title: title
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $1s5hv = parcelRequire("1s5hv");









const $639589a78901fac2$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $639589a78901fac2$var$styles = {
    content: "_4t3i1osq",
    image: "_bfhkysee",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageSmall: "_1ul9i9or",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    bodySmall: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    itemCommon: "_4t3iftgi _bfhkysee",
    title: "_1bsbldb6",
    publishedDate: "_1bsb1osq",
    descriptionFirstLine: "_1bsbs0l4",
    descriptionSecondLine: "_1bsb1ame",
    titleLarge: "_1bsb12am",
    descriptionFirstLineLarge: "_1bsbuuw1",
    descriptionSecondLineLarge: "_1bsb1178"
};
const $639589a78901fac2$var$ContentSmall = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $639589a78901fac2$var$styles.content,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.image, $639589a78901fac2$var$styles.imageSmall)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.050",
                xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.body, $639589a78901fac2$var$styles.bodySmall),
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, $639589a78901fac2$var$styles.title)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, $639589a78901fac2$var$styles.publishedDate)
                    })
                ]
            })
        ]
    });
const $639589a78901fac2$var$Content = ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize })=>{
    const isLargeCard = cardSize === (0, $4cOi8.Height).LARGE;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: $639589a78901fac2$var$styles.content,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.image, isImageFixedHeight ? isLargeCard ? $639589a78901fac2$var$styles.imageFixedHeightLarge : $639589a78901fac2$var$styles.imageFixedHeightMedium : $639589a78901fac2$var$styles.imageFlexibleHeight)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.075",
                xcss: $639589a78901fac2$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, isLargeCard ? $639589a78901fac2$var$styles.titleLarge : $639589a78901fac2$var$styles.title)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, $639589a78901fac2$var$styles.publishedDate)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, isLargeCard ? $639589a78901fac2$var$styles.descriptionFirstLineLarge : $639589a78901fac2$var$styles.descriptionFirstLine)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, isLargeCard ? $639589a78901fac2$var$styles.descriptionSecondLineLarge : $639589a78901fac2$var$styles.descriptionSecondLine)
                    })
                ]
            })
        ]
    });
};
const $639589a78901fac2$export$f67f215fe23c6b24 = ({ cardDimensions: cardDimensions, cardSize: cardSize, layout: layout })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const containerId = `${cardSize}-card-loading-state`;
    if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $4cOi8.Height).SMALL) return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v2`,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                minHeight: minHeight,
                maxHeight: maxHeight
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($639589a78901fac2$var$Content, {
                isImageFixedHeight: true,
                cardSize: cardSize
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v1`,
        cardHeight: height,
        children: cardSize === (0, $4cOi8.Height).SMALL ? /*#__PURE__*/ (0, $l998X.jsx)($639589a78901fac2$var$ContentSmall, {}) : /*#__PURE__*/ (0, $l998X.jsx)($639589a78901fac2$var$Content, {
            cardSize: cardSize
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");










const $35e23058e7b3e321$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    previous: {
        id: "company-hub.cards-extension.row-orientation.previous",
        defaultMessage: "Previous"
    },
    next: {
        id: "company-hub.cards-extension.row-orientation.next",
        defaultMessage: "Next"
    }
});


const $4869bd40ed92a09c$var$styles = {
    footer: "_1bah1yb4 _4cvr1h6o _ca0q12x7",
    footerNav: "_zulp1b66 _18u01wug",
    iconBackgroundColor: "_2rko1rr0 _bfhk1bhr"
};
const $4869bd40ed92a09c$export$d1f75a226e49cd83 = ({ isStacked: isStacked, showAIDisclaimer: showAIDisclaimer, allCardsShown: allCardsShown, isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext })=>{
    const showFooter = showAIDisclaimer || !isStacked && !allCardsShown;
    if (!showFooter) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        testId: "link-cards-content-cards-row-navigation",
        xcss: (0, $1Whri.cx)($4869bd40ed92a09c$var$styles.footer, isStacked && !showAIDisclaimer && $4869bd40ed92a09c$var$styles.footerNav),
        children: [
            showAIDisclaimer && /*#__PURE__*/ (0, $l998X.jsx)((0, $bGmGb.CardsAIDisclaimer), {}),
            !isStacked && !allCardsShown && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $4869bd40ed92a09c$var$styles.footerNav,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: $4869bd40ed92a09c$var$styles.iconBackgroundColor,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                            isDisabled: isAtBeginning,
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $35e23058e7b3e321$export$defe85febe8b728c).previous
                            }),
                            onClick: scrollToPrevious
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: $4869bd40ed92a09c$var$styles.iconBackgroundColor,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                            isDisabled: isAtEnd,
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $35e23058e7b3e321$export$defe85febe8b728c).next
                            }),
                            onClick: scrollToNext
                        })
                    })
                ]
            })
        ]
    });
};


const $75ac03d5ea4b0323$var$styles = {
    cardWrapper: "_4t3i1osq"
};
const $75ac03d5ea4b0323$var$CARD_SIZE_FLEXIBLE_MAP = {
    [(0, $4cOi8.Height).SMALL]: (0, $a9e75a3820d58e12$export$5c35843a47cb7bc4),
    [(0, $4cOi8.Height).MEDIUM]: (0, $39e9dc6831e8ee6a$export$42440eb4dfc95ce7),
    [(0, $4cOi8.Height).LARGE]: (0, $13e5f254f9926788$export$299421c7aa71f32d)
};
const $75ac03d5ea4b0323$var$CARD_SIZE_FIXED_MAP = {
    [(0, $4cOi8.Height).SMALL]: (0, $a9e75a3820d58e12$export$5c35843a47cb7bc4),
    [(0, $4cOi8.Height).MEDIUM]: (0, $10bd7f32a1f45b52$export$b38e9910221b4e7e),
    [(0, $4cOi8.Height).LARGE]: (0, $b85a19d2e323979a$export$a59c193ce67944a7)
};
const $75ac03d5ea4b0323$var$getCardComponent = (cardSize, layout)=>{
    if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT) return $75ac03d5ea4b0323$var$CARD_SIZE_FIXED_MAP[cardSize] ?? (0, $10bd7f32a1f45b52$export$b38e9910221b4e7e);
     // Default to flexible cards (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
    return $75ac03d5ea4b0323$var$CARD_SIZE_FLEXIBLE_MAP[cardSize] ?? (0, $39e9dc6831e8ee6a$export$42440eb4dfc95ce7);
};
const $75ac03d5ea4b0323$export$bab15f92b6d84cb6 = ({ extensionLocalId: extensionLocalId, parameters: parameters, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode, contentId: contentId })=>{
    const validatedCardParams = (0, $7165bea3d0a8ca43$export$9a666555160249c1)(parameters);
    const { renderVariant: renderVariant, size: size, isDescriptionShown: isDescriptionShown, layout: layout } = validatedCardParams;
    const isDynamicCards = renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC;
    const cardDimensions = (0, $e41f25d61305a67d$export$90cc9ab68d35b5b9)({
        cardSize: size,
        layout: layout
    });
    const CardComponent = $75ac03d5ea4b0323$var$getCardComponent(size, layout); // checking specifically if isDescriptionShown is false because if it's undefined,
    // it means that the dynamic cards were created from before and we want to show the descriptions they had
    const showDescription = renderVariant === (0, $4cOi8.RenderVariant).MANUAL || isDescriptionShown !== false; /* only autoscroll cards when all below conditions meet:
                                                                                                   * 1. is in company hub
                                                                                                   * 2. orientation is in row (handled in validateCardParams)
                                                                                                   * 3. Autoscroll toggle is on
                                                                                                   * 4. user is in renderer
                                                                                                   * cards macro now includes features that are company hub specific. These features will be hidden for macros in non-hub pages
                                                                                                   * for more details refer to https://hello.atlassian.net/wiki/spaces/CLI/pages/4436003008/Hub+only+features
                                                                                                   */ 
    const shouldAutoscrollCards = Boolean(isCompanyHub && validatedCardParams.isAutoscrollEnabled && isInViewMode);
    const CardsContentComponent = isDynamicCards ? $75ac03d5ea4b0323$var$DynamicCardsContent : $75ac03d5ea4b0323$var$ManualCardsContent;
    return /*#__PURE__*/ (0, $l998X.jsx)(CardsContentComponent, {
        extensionLocalId: extensionLocalId,
        parameters: validatedCardParams,
        isCompanyHub: isCompanyHub,
        isTargetAudience: isTargetAudience,
        isInViewMode: isInViewMode,
        contentId: contentId,
        cardDimensions: cardDimensions,
        shouldAutoscrollCards: shouldAutoscrollCards,
        CardComponent: CardComponent,
        showDescription: showDescription
    });
};
const $75ac03d5ea4b0323$var$CardsContainer = ({ extensionLocalId: extensionLocalId, numberOfCards: numberOfCards, cardDimensions: cardDimensions, isStacked: isStacked, alignment: alignment, cards: cards, renderCard: renderCard, isInViewMode: isInViewMode, shouldAutoscrollCards: shouldAutoscrollCards, showAIDisclaimer: showAIDisclaimer })=>shouldAutoscrollCards ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d1c18879ec5e414d$export$ac70d6b7d7a09503), {
        testId: "cards-extension",
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc545f2775878ae$export$37f8d84bb48ae4b7), {
        testId: "cards-extension",
        extensionLocalId: extensionLocalId,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: isStacked,
        isInViewMode: isInViewMode,
        alignment: alignment,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer,
        cardsContentFooter: (0, $4869bd40ed92a09c$export$d1f75a226e49cd83)
    });
const $75ac03d5ea4b0323$var$ManualCardsContent = ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription = true })=>{
    const { isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, cards: cards, isSegmentationShown: isSegmentationShown, isLabelShown: isLabelShown, orientation: orientation, alignment: alignment, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle } = parameters;
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $18092cac9334e981$export$c6c5cac0793c45d9)(cards);
    const { filteredCards: filteredCards } = (0, $ef7e4501b98ea11b$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cards,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $fOKpq.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = filteredCards.length;
    const renderManualCard = (0, $42omo.useCallback)((card)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.075",
            xcss: (0, $1Whri.cx)($75ac03d5ea4b0323$var$styles.cardWrapper),
            children: /*#__PURE__*/ (0, $l998X.jsx)(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: isInViewMode,
                isLabelShown: isLabelShown,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                isManualVariant: true,
                extensionLocalId: extensionLocalId,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerStyle: cornerStyle,
                showDescription: showDescription,
                ...card
            })
        }, card.cardId);
    }, [
        extensionLocalId,
        contentId,
        cardDimensions,
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isLabelShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        backgroundColor,
        textColor,
        borderColor,
        cornerStyle
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($75ac03d5ea4b0323$var$CardsContainer, {
                shouldAutoscrollCards: shouldAutoscrollCards,
                numberOfCards: numberOfCards,
                cardDimensions: cardDimensions,
                isStacked: orientation === (0, $5un3P.Orientation).STACKED,
                isInViewMode: isInViewMode,
                alignment: alignment,
                extensionLocalId: extensionLocalId,
                cards: filteredCards,
                renderCard: renderManualCard
            }),
            areAllItemsLoaded && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceSuccess, {}),
            !!itemFailureError && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceError, {
                error: itemFailureError
            })
        ]
    });
};
const $75ac03d5ea4b0323$var$DynamicCardsContent = ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription })=>{
    const { size: size, orientation: orientation, alignment: alignment, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, filters: filters, isSegmentationShown: isSegmentationShown, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, layout: layout } = parameters;
    const { cards: cards, loading: loading, error: error } = (0, $08734f16b0a13216$export$5fe928848609fec7)(parameters);
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $18092cac9334e981$export$c6c5cac0793c45d9)(cards);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $fOKpq.useProductDependencies)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $fOKpq.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = cards.length;
    const showAIDisclaimer = isAdminHubAIEnabled && showDescription && numberOfCards > 0 && size !== (0, $4cOi8.Height).SMALL;
    let cardsWithEmptyDefault = cards;
    if (!filters || !numberOfCards || loading) cardsWithEmptyDefault = (0, (/*@__PURE__*/$parcel$interopDefault($069d581736ad089f$exports)))(3, ()=>({
            cardId: '',
            link: ''
        }));
    const { filteredCards: filteredCards } = (0, $ef7e4501b98ea11b$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cardsWithEmptyDefault,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const renderDynamicCard = (0, $42omo.useCallback)((card)=>{
        const isResultEmpty = !numberOfCards || !card?.link;
        if (!filters) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eacc84e085bad39b$export$15b55049a5f7f585), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout,
            state: (0, $eacc84e085bad39b$export$fddf379e22a74b00).NO_FILTER
        });
        if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $639589a78901fac2$export$f67f215fe23c6b24), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout
        });
        if (isResultEmpty) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eacc84e085bad39b$export$15b55049a5f7f585), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout,
            state: (0, $eacc84e085bad39b$export$fddf379e22a74b00).NO_RESULTS
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.075",
            xcss: (0, $1Whri.cx)($75ac03d5ea4b0323$var$styles.cardWrapper),
            children: /*#__PURE__*/ (0, $l998X.jsx)(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: !!isInViewMode,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerStyle: cornerStyle,
                enableSnippetRenderer: true,
                showDescription: showDescription,
                ...card
            })
        }, card.cardId);
    }, [
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        filters,
        size,
        contentId,
        cardDimensions,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        loading,
        backgroundColor,
        textColor,
        borderColor,
        cornerStyle,
        layout,
        numberOfCards
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($75ac03d5ea4b0323$var$CardsContainer, {
                shouldAutoscrollCards: shouldAutoscrollCards,
                numberOfCards: numberOfCards,
                cardDimensions: cardDimensions,
                isStacked: orientation === (0, $5un3P.Orientation).STACKED,
                isInViewMode: isInViewMode,
                alignment: alignment,
                extensionLocalId: extensionLocalId,
                cards: filteredCards,
                renderCard: renderDynamicCard,
                showAIDisclaimer: showAIDisclaimer
            }),
            error && /*#__PURE__*/ (0, $l998X.jsx)((0, $92f476fa60bd9f29$export$533cd3269e981a31), {
                error: error
            }),
            areAllItemsLoaded && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceSuccess, {}),
            !!itemFailureError && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceError, {
                error: itemFailureError
            })
        ]
    });
};


const $3843dc6c886aff87$export$9db933359d5c5243 = ({ extensionNode: extensionNode, contentId: contentId, mode: mode = (0, $4cOi8.ExtensionMode).RENDERER })=>{
    const { isTargetAudience: isTargetAudience, isCompanyHub: isCompanyHub, smartCardProviderComponent: smartCardProviderComponent } = (0, $fOKpq.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $42omo.Fragment);
    const { parameters: parameters, localId: localId = '' } = extensionNode || {};
    if (!parameters) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Yx9c.HubExtensionsWrapper), {
        mode: mode,
        extensionNode: extensionNode,
        contentId: contentId,
        showNoDataState: !parameters,
        packageName: "cards-extension",
        analyticsAttributes: {
            renderVariant: parameters?.renderVariant,
            version: parameters?.version,
            isCompanyHub: isCompanyHub,
            hubSegementationApplied: parameters?.isSegmentationShown
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)(SmartCardProvider, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $75ac03d5ea4b0323$export$bab15f92b6d84cb6), {
                extensionLocalId: localId,
                parameters: parameters,
                isCompanyHub: isCompanyHub,
                isTargetAudience: isTargetAudience,
                isInViewMode: mode === (0, $4cOi8.ExtensionMode).RENDERER,
                contentId: contentId
            })
        })
    });
};
const $3843dc6c886aff87$export$4956ae2d90a2bbeb = ({ propsProvider: PropsProvider, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)(PropsProvider, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)($3843dc6c886aff87$export$9db933359d5c5243, {
            ...props
        })
    });
module.exports["CardsExtensionBase"] = $3843dc6c886aff87$export$9db933359d5c5243;
module.exports["CardsExtension"] = $3843dc6c886aff87$export$4956ae2d90a2bbeb;

});

parcelRegister("1Yx9c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");


var $fOKpq = parcelRequire("fOKpq");


var $4cOi8 = parcelRequire("4cOi8");


var $1m9A2 = parcelRequire("1m9A2");


var $8Ixq2 = parcelRequire("8Ixq2");


var $jrlgF = parcelRequire("jrlgF");


var $glqE9 = parcelRequire("glqE9");

const $b3bbb984d806269d$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $4cOi8.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $fOKpq.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $42omo.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $jrlgF.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {})
    };
    (0, $42omo.useEffect)(()=>{
        if (mode === (0, $4cOi8.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: extensionKey || 'unknown-hub-extension',
        children: /*#__PURE__*/ (0, $l998X.jsxs)(ErrorBoundaryComponent, {
            ...errorBoundaryProps,
            shouldForceError: (0, $glqE9.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || ''),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ExperienceStart, {}),
                hasParameters ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
                    source: extensionKey
                })
            ]
        })
    });
};
module.exports["HubExtensionsWrapper"] = $b3bbb984d806269d$export$1b8348eac06ebe09;

});

parcelRegister("1m9A2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $fOKpq = parcelRequire("fOKpq");


var $harUV = parcelRequire("harUV");


var $dE8aF = parcelRequire("dE8aF");

const $947dafb4b85c32e6$var$styles = {
    baseStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o",
    configPanelStyles: "_4t3i1vuk",
    extensionStyles: "_4t3i1osq"
};
const $947dafb4b85c32e6$export$dd91c9257a0f1cd4 = ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $42omo.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($947dafb4b85c32e6$var$styles.baseStyles, isConfigPanel ? $947dafb4b85c32e6$var$styles.configPanelStyles : $947dafb4b85c32e6$var$styles.extensionStyles),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
            header: intl.formatMessage((0, $dE8aF.messages).noDataStateHeaderText),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $dE8aF.messages).noDataStateDescription
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($harUV)))
        })
    });
};
module.exports["NoExtensionData"] = $947dafb4b85c32e6$export$dd91c9257a0f1cd4;

});

parcelRegister("harUV", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("dE8aF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8bb95c815845532f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8bb95c815845532f$export$defe85febe8b728c;

});

parcelRegister("glqE9", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $97dcfab536b484ac$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $97dcfab536b484ac$export$3617e2677e53ded6;

});

parcelRegister("hRuRu", function(module, exports) {

var $eN7zR = parcelRequire("eN7zR");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $d00f536c1934c36c$var$castFunction(value) {
    return typeof value == 'function' ? value : $eN7zR;
}
module.exports = $d00f536c1934c36c$var$castFunction;

});

parcelRegister("IBZYB", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8dfa4f5c71224290$export$3d5265f8773197d = ({ maxNumberOfItemsPerRow: maxNumberOfItemsPerRow, numberOfItems: numberOfItems, isRow: isRow })=>{
    // Indices represents the leftmost item and rightmost item currently in view.
    const [window, setWindow] = (0, $42omo.useState)([
        0,
        0
    ]);
    // Used for scrolling to a particular item. Set to -1 by default as we haven't scrolled yet.
    const [scrollToIndex, setScrollToIndex] = (0, $42omo.useState)(-1);
    // Used to keep track of which item is currently being edited in the config panel to adjust window accordingly.
    const [requestedScrollIndex, setRequestedScrollIndex] = (0, $42omo.useState)(-1);
    (0, $42omo.useEffect)(()=>{
        {
            // Viewable window indexes are inclusive of left and right index, so we need to decrement by one unless maxNumberOfItemsPerRow is 0.
            // Examples:
            // Cards: 1 2 3 4 5, Card indexes: 0 1 2 3 4
            // maxNumberOfItemsPerRow is 0, current left index is at card 1 (ie. index 0) --> right index should be at card 1 (index 0), 1 card in view. Calculation: 0 + 0 - 0 = 0
            // maxNumberOfItemsPerRow is 2, current left index is at card 1 (ie. index 0) --> right index should be at card 2 (index 1), 2 cards in view. Calculation: 0 + 2 - 1 = 1
            // maxNumberOfItemsPerRow is 3, current left index is at card 2 (ie. index 1) --> right index should be at card 4 (index 3), 3 cards in view. Calculation: 1 + 3 - 1 = 3
            const extraDecrement = maxNumberOfItemsPerRow === 0 ? 0 : 1;
            const newRightIndex = window[0] + maxNumberOfItemsPerRow - extraDecrement;
            setWindow([
                window[0],
                newRightIndex
            ]);
        }
        if (requestedScrollIndex >= 0) {
            // Trigger scroll unconditionally, this works for grid view as well (which doesn't use the window logic)
            setScrollToIndex(requestedScrollIndex);
            // Only update the window in row orientation, as we don't use a window for grid view.
            if (isRow) {
                if (requestedScrollIndex !== window[0] && requestedScrollIndex !== window[1]) {
                    // This means we've scrolled somewhere left beyond the existing visible window, so we update the window to the left.
                    if (requestedScrollIndex < window[0]) setWindow([
                        requestedScrollIndex,
                        requestedScrollIndex + maxNumberOfItemsPerRow - 1
                    ]);
                    else if (requestedScrollIndex > window[1]) setWindow([
                        requestedScrollIndex - maxNumberOfItemsPerRow + 1,
                        requestedScrollIndex
                    ]);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        maxNumberOfItemsPerRow,
        requestedScrollIndex,
        isRow
    ]);
    const scrollToPrevious = (0, $42omo.useCallback)(()=>{
        const newLeftIndex = window[0] - 1;
        const newRightIndex = window[1] - 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newLeftIndex);
    }, [
        window
    ]);
    const scrollToNext = ()=>{
        const newLeftIndex = window[0] + 1;
        const newRightIndex = window[1] + 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newRightIndex);
    };
    (0, $42omo.useEffect)(()=>{
        // If user deletes an item near the end of the list, our window of
        // items being shown may need recalculating (if right index is too high)
        if (window[1] > numberOfItems - 1 && window[0] > 0) scrollToPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numberOfItems,
        scrollToPrevious
    ]);
    const noScrollNeeded = numberOfItems <= maxNumberOfItemsPerRow;
    const isAtBeginning = noScrollNeeded || window[0] === 0;
    const isAtEnd = noScrollNeeded || window[1] === numberOfItems - 1;
    const resetScrollIndex = ()=>{
        setScrollToIndex(-1);
    };
    return {
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext,
        scrollToIndex: scrollToIndex,
        requestScrollIndex: setRequestedScrollIndex,
        resetScrollIndex: resetScrollIndex
    };
};
module.exports["useOrientationScrolling"] = $8dfa4f5c71224290$export$3d5265f8773197d;

});

parcelRegister("lPcXt", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fea56e716edbc72a$export$1a197eb476b94cd9 = 16;
const $fea56e716edbc72a$export$622d6c2ee56322dc = 16;
const $fea56e716edbc72a$var$MAX_NUMBER_OF_ITEMS_PER_ROW = 6;
const $fea56e716edbc72a$export$a6443181a5681c94 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, getItemDimensions: getItemDimensions })=>{
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $42omo.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $42omo.useState)(0);
    const dimensions = getItemDimensions ? getItemDimensions() : cardDimensions;
    /*
	 * Width observer rounds the width of the container (currentCardsGridWidth) returning a whole number.
	 * This means in situations that the width is rounded up, we have an edge case where we are
	 * making calculations with a grid width larger than what we actually have leading to layout issues.
	 *
	 * It is better to adjust the width we get from the observer down (-.5px) and
	 * have some cases where we have extra space (<=.5px) than the latter problem that causes layout issues.
	 */ const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + $fea56e716edbc72a$export$1a197eb476b94cd9) / (dimensions.minWidth + $fea56e716edbc72a$export$1a197eb476b94cd9));
    const maxNumberOfCardsPerRow = Math.min(numberOfCardsPerRow, $fea56e716edbc72a$var$MAX_NUMBER_OF_ITEMS_PER_ROW);
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) return {
        calculations: {
            cardWidthOnFullRow: dimensions.minWidth,
            isFirstRowFull: true,
            isFirstRowOverflown: false,
            isGridSmallerOrEqualWidthToCards: true,
            gaps: {
                spaceBetweenCards: $fea56e716edbc72a$export$1a197eb476b94cd9,
                paddingRightGapOffset: 0
            },
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        },
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - $fea56e716edbc72a$export$1a197eb476b94cd9 * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * $fea56e716edbc72a$export$1a197eb476b94cd9;
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $fea56e716edbc72a$export$622d6c2ee56322dc - $fea56e716edbc72a$export$1a197eb476b94cd9);
    const spaceBetweenCards = $fea56e716edbc72a$export$1a197eb476b94cd9 + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    const calculations = {
        cardWidthOnFullRow: cardWidthOnFullRow,
        isFirstRowFull: isFirstRowFull,
        isFirstRowOverflown: isFirstRowOverflown,
        isGridSmallerOrEqualWidthToCards: false,
        gaps: {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        },
        maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
    };
    return {
        calculations: calculations,
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
};
module.exports["useWidthAndSpacingCalculations"] = $fea56e716edbc72a$export$a6443181a5681c94;

});

parcelRegister("ahPKE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4JDbp = parcelRequire("4JDbp");


var $g3LxX = parcelRequire("g3LxX");


var $4cOi8 = parcelRequire("4cOi8");

const $067bbf2166381c77$export$efa81a508b70a345 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $067bbf2166381c77$export$1928c8795f1f40c6 = (cardSize)=>{
    return $067bbf2166381c77$export$efa81a508b70a345[cardSize];
};
const $067bbf2166381c77$var$styles = {
    wrapperStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1rjcv77o _kqswh2mm _2mzuglyw _19pkze3t",
    wrapperWithInlinePadding: "_18zrv77o"
};
const $067bbf2166381c77$export$11b226df951ea813 = ({ children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: testId = 'card-wrapper', scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: hasInlinePadding = false, ariaRole: ariaRole })=>{
    const cardRef = (0, $42omo.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const cardDimensions = itemDimensions;
    (0, $42omo.useEffect)(()=>{
        const scrollIntoViewBehavior = {
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        };
        if (cardRef.current) {
            // Scroll to this card as long as its config panel is open OR no config panel is open.
            // If no config panel is open, that covers the case in edit mode where user has clicked
            // scroll buttons on a row-oriented cards instance which they aren't actively editing.
            if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                cardRef.current.scrollIntoView(scrollIntoViewBehavior); // Clear scrollIndex to prevent re-invoking scroll effect later unexpectedly
                clearScrollToCard();
            } // Handle the case where user has selected this card to edit from the config panel.
            if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) // Now that we've reached the right card that user is selecting to edit,
            // trigger the scrolling hook to recalculate scroll window and index so
            // that we can rerender invoking the scroll effect
            requestScrollIndex(index);
            else if (!selectedToEditCardId) // if no card is selected to edit, set index to -1 indicate that it is not currently being used
            requestScrollIndex(-1);
        }
    }, [
        cardRef,
        cardId,
        extensionLocalId,
        index,
        scrollToCard,
        clearScrollToCard,
        selectedExtensionLocalId,
        selectedToEditCardId,
        requestScrollIndex
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        role: ariaRole,
        style: {
            minWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`,
            maxWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`
        },
        ref: cardRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $067bbf2166381c77$var$styles.wrapperStyles,
            hasInlinePadding && $067bbf2166381c77$var$styles.wrapperWithInlinePadding
        ]),
        children: [
            children,
            index === 0 && setWidth && /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                setWidth: setWidth,
                offscreen: true
            })
        ]
    });
};
module.exports["CardOrientationWrapper"] = $067bbf2166381c77$export$11b226df951ea813;

});

parcelRegister("7YEWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0545074a7ad6867d320b793a6025aac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cede6a65f901a4e$var$_react = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("42omo")));

var $5cede6a65f901a4e$var$_baseNew = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5cede6a65f901a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cede6a65f901a4e$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $5cede6a65f901a4e$var$_react.default.createElement($5cede6a65f901a4e$var$_baseNew.default, Object.assign({
        name: "VideoPauseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5cede6a65f901a4e$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $5cede6a65f901a4e$var$_default = module.exports.default = $5cede6a65f901a4e$var$VideoPauseIcon;

});

parcelRegister("3LC7V", function(module, exports) {
/**
 * This file contains export components and API for FlexibleCard components.
 * For internal usage for access to all available props, please use following
 * - ./components/elements for metadata component
 * - ./components/actions for action component
 *
 * DO NOT add a new prop to these components until we are ready to support it externally.
 */ 
var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $apOlf = parcelRequire("apOlf");

var $6FZ6a = parcelRequire("6FZ6a");

var $cLh5D = parcelRequire("cLh5D");

var $9l03X = parcelRequire("9l03X");

var $2vLbR = parcelRequire("2vLbR");

var $lVA2Y = parcelRequire("lVA2Y");


var $6cbph = parcelRequire("6cbph");

var $4wLtQ = parcelRequire("4wLtQ");

var $iNImz = parcelRequire("iNImz");

var $LrBxG = parcelRequire("LrBxG");

var $bWsCB = parcelRequire("bWsCB");

var $azCqP = parcelRequire("azCqP");

var $kexiH = parcelRequire("kexiH");

var $3nul2 = parcelRequire("3nul2");

var $e8W8a = parcelRequire("e8W8a");

var $jKoRo = parcelRequire("jKoRo");

var $bmx11 = parcelRequire("bmx11");

var $jI5eg = parcelRequire("jI5eg");

var $8iOdP = parcelRequire("8iOdP");

var $jW9GW = parcelRequire("jW9GW");

var $1WqHG = parcelRequire("1WqHG");

var $ful5o = parcelRequire("ful5o");

var $41AV3 = parcelRequire("41AV3");

var $ikM9T = parcelRequire("ikM9T");

var $8YJtM = parcelRequire("8YJtM");

var $6Ed8U = parcelRequire("6Ed8U");

var $2ZgNz = parcelRequire("2ZgNz");

var $iuEuh = parcelRequire("iuEuh");

var $2GDee = parcelRequire("2GDee");

var $h2WFd = parcelRequire("h2WFd");

var $49WiA = parcelRequire("49WiA");

var $aGsNO = parcelRequire("aGsNO");

var $emfmd = parcelRequire("emfmd");

var $jpKes = parcelRequire("jpKes");

var $a0Yyn = parcelRequire("a0Yyn");

var $b8mrt = parcelRequire("b8mrt");

var $hIbqn = parcelRequire("hIbqn");

var $gHW9t = parcelRequire("gHW9t");

var $zH0mb = parcelRequire("zH0mb");

var $6LJqp = parcelRequire("6LJqp");

const $18cd6f93eedff66b$export$46d56fa2aa324fa6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cbph.default), null);
const $18cd6f93eedff66b$export$c1142bebae312275 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4wLtQ.default), null);
const $18cd6f93eedff66b$export$fd86792b0d618eef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNImz.default), null);
const $18cd6f93eedff66b$export$85c1cdc45fbd445c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $LrBxG.default), null);
const $18cd6f93eedff66b$export$ceec5736924de4d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWsCB.default), null);
const $18cd6f93eedff66b$export$145bed937364849e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $azCqP.default), null);
const $18cd6f93eedff66b$export$a43b6bbf2f1b5e96 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kexiH.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
const $18cd6f93eedff66b$export$fcb9afb4cbcee73a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e8W8a.default), null);
const $18cd6f93eedff66b$export$85780eaea5e9340b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3nul2.default), null);
const $18cd6f93eedff66b$export$514e2dbf44bf7dec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jKoRo.default), null);
const $18cd6f93eedff66b$export$a8c002f6544d07d4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bmx11.default), null);
const $18cd6f93eedff66b$export$4d177e8e493d864d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        size: props?.iconTileSize === 24 ? (0, $5TXU5.SmartLinkSize).Large : (0, $5TXU5.SmartLinkSize).Medium,
        render: props?.render
    });
};
const $18cd6f93eedff66b$export$af6f82ac48d2952d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8iOdP.default), null);
const $18cd6f93eedff66b$export$6ddb078bc7afcbf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jW9GW.default), null);
const $18cd6f93eedff66b$export$cb2b1990006f041b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1WqHG.default), {
        hideDatePrefix: props?.hideDatePrefix,
        color: props?.color,
        onRender: props?.onRender,
        fontSize: props?.fontSize
    });
};
const $18cd6f93eedff66b$export$d630834382353545 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ful5o.default), {
        hideFormat: props?.hideFormat,
        color: props?.color,
        onRender: props?.onRender,
        textPrefix: props?.textPrefix,
        fontSize: props?.fontSize
    });
};
const $18cd6f93eedff66b$export$633ffcc4029e4e39 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $41AV3.default), {
        onRender: props?.onRender
    });
};
const $18cd6f93eedff66b$export$5b3c009928f1ce72 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikM9T.default), {
        overrideUrl: props?.url
    });
};
const $18cd6f93eedff66b$export$9f98f75e82cffae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8YJtM.default), null);
const $18cd6f93eedff66b$export$dc976923d15b4909 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ed8U.default), null);
const $18cd6f93eedff66b$export$7fce19392096f26f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZgNz.default), null);
const $18cd6f93eedff66b$export$5ecf9c2b4f9ce084 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iuEuh.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
const $18cd6f93eedff66b$export$27f88025ed20e742 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GDee.default), null);
const $18cd6f93eedff66b$export$c49fe7f9d49294b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h2WFd.default), null);
const $18cd6f93eedff66b$export$80ac7ae64759451e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49WiA.default), {
        maxLines: props?.maxLines,
        content: props?.text
    });
const $18cd6f93eedff66b$export$f56004dbb02efc8a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aGsNO.default), null);
const $18cd6f93eedff66b$export$28ad9e2ec019f34c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emfmd.default), {
        maxWidth: props?.maxWidth
    });
const $18cd6f93eedff66b$export$2815de51cd1f37b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpKes.default), null);
const $18cd6f93eedff66b$export$8d3e182130d8b766 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0Yyn.default), null);
const $18cd6f93eedff66b$export$3d178478c7cef7e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8mrt.default), null);
const $18cd6f93eedff66b$export$da2d835ee85f951d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hIbqn.default), null);
const $18cd6f93eedff66b$export$56726d258a7004ee = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gHW9t.default), {
        hideTooltip: props?.hideTooltip,
        maxLines: props?.maxLines,
        target: props?.target,
        theme: props?.theme,
        size: props?.size,
        testId: props?.testId,
        ...props?.text ? {
            text: props?.text
        } : undefined
    });
const $18cd6f93eedff66b$export$fff7f783105f14f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $zH0mb.default), null);
const $18cd6f93eedff66b$export$b5dd74337242162e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6LJqp.default), null);
const $18cd6f93eedff66b$export$b639603370d1ca44 = (props)=>({
        appearance: props?.appearance ?? 'default',
        icon: undefined
    });
const $18cd6f93eedff66b$export$4c2bfaba2cf0128a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $apOlf.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$b605bf507f6a39c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ...$18cd6f93eedff66b$export$b639603370d1ca44(props),
        content: props.children,
        onClick: props.onClick
    });
const $18cd6f93eedff66b$export$7a2b423858a679ca = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cLh5D.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$efdca248636f91bf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9l03X.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$56dfecf361778c5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2vLbR.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$8687dc32e81b32c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lVA2Y.default), props);
module.exports["CommentCountElement"] = $18cd6f93eedff66b$export$a43b6bbf2f1b5e96;
module.exports["LinkIconElement"] = $18cd6f93eedff66b$export$4d177e8e493d864d;
module.exports["ModifiedOnElement"] = $18cd6f93eedff66b$export$cb2b1990006f041b;
module.exports["OwnedByElement"] = $18cd6f93eedff66b$export$d630834382353545;
module.exports["OwnedByGroupElement"] = $18cd6f93eedff66b$export$633ffcc4029e4e39;
module.exports["ReactCountElement"] = $18cd6f93eedff66b$export$5ecf9c2b4f9ce084;
module.exports["UnresolvedAction"] = $18cd6f93eedff66b$export$8687dc32e81b32c2;

});

parcelRegister("aPwHF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");

const $fbac79744aa5216e$export$9e87ed1f12141293 = (cardId, link, onCardSucceeded, onCardFailed)=>{
    const [isResolved, setIsResolved] = (0, $42omo.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $42omo.useState)('');
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $42omo.useRef)(false);
    // Other error types [`errored`, `fallback`] should not be caught. We will let the card UI render, even though
    // the SmartCard cannot fetch data for them
    const isRestricted = errorCardStatus === 'forbidden';
    const isUnauthorized = errorCardStatus === 'unauthorized';
    const isNoResult = errorCardStatus === 'not_found';
    (0, $42omo.useEffect)(()=>{
        setErrorCardStatus('');
    }, [
        link,
        setErrorCardStatus
    ]);
    const failExperienceAndSendErrorMonitoring = (0, $42omo.useCallback)((err)=>{
        onCardFailed(err);
        submitError?.(err);
    }, [
        onCardFailed,
        submitError
    ]);
    const trackAndCategorizeError = (0, $42omo.useCallback)(({ status: status, err: err })=>{
        setErrorCardStatus(status);
        setIsResolved(true);
        if (status === 'unauthorized') shouldPreserveErrorStatus.current = true;
        if (err) failExperienceAndSendErrorMonitoring(err);
        else onCardSucceeded(cardId);
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded,
        failExperienceAndSendErrorMonitoring
    ]);
    const trackSuccess = (0, $42omo.useCallback)(()=>{
        onCardSucceeded(cardId);
        setIsResolved(true);
        // For Smart Cards with an unauthorized state, it calls onResolve, but we don't want to clear the error status.
        // shouldPreserveErrorStatus is used b/c we need to skip clearing the error status for one cycle
        if (shouldPreserveErrorStatus.current) {
            shouldPreserveErrorStatus.current = false;
            return;
        }
        setErrorCardStatus('');
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded
    ]);
    return {
        isNoResult: isNoResult,
        isRestricted: isRestricted,
        isUnauthorized: isUnauthorized,
        errorCardStatus: errorCardStatus,
        isResolved: isResolved,
        trackAndCategorizeError: trackAndCategorizeError,
        trackSuccess: trackSuccess
    };
};
module.exports["useTrackedSmartCardState"] = $fbac79744aa5216e$export$9e87ed1f12141293;

});

parcelRegister("e0Oqq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fT2ta = parcelRequire("fT2ta");

const $c85123d895112cbb$var$skeletonWrapperStyles = null;
const $c85123d895112cbb$var$emojiSkeletonStyles = null;
const $c85123d895112cbb$export$9fc60f86d5a6479f = ({ height: height, loadingMargin: loadingMargin })=>{
    const PLACEHOLDER_SIZE = height;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
        entranceDirection: "left",
        children: (animationProps)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        width: `${PLACEHOLDER_SIZE}px`,
                        height: `${PLACEHOLDER_SIZE}px`,
                        margin: loadingMargin
                    },
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1o8l _bfhkizff _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t"
                    ])
                })
            })
    });
};
module.exports["EmojiPlaceholder"] = $c85123d895112cbb$export$9fc60f86d5a6479f;

});

parcelRegister("5oWvd", function(module, exports) {

let $3eec92ff24af9aa2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3eec92ff24af9aa2$var$load("ijAU0"),
    $3eec92ff24af9aa2$var$load("1WCMN"),
    $3eec92ff24af9aa2$var$load("6wr18"),
    $3eec92ff24af9aa2$var$load("ffEVr"),
    $3eec92ff24af9aa2$var$load("mYwau")
]).then(()=>parcelRequire('45jPm'));

});

parcelRegister("g50oa", function(module, exports) {
module.exports = new URL("NoDynamicCards.7cd8fd7d.svg", import.meta.url).toString();

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("euACo", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $035a46a85e451274$var$iconStyles = null;
const $035a46a85e451274$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $035a46a85e451274$var$baseHcmStyles = null;
const $035a46a85e451274$var$primaryEqualsSecondaryHcmStyles = null;
const $035a46a85e451274$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $035a46a85e451274$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $l998X.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $035a46a85e451274$var$sizeStyles[size]
        ])
    });
});
var $035a46a85e451274$export$2e2bcd8739ae039 = $035a46a85e451274$export$f04a61298a47a40f;
module.exports["Icon"] = $035a46a85e451274$export$f04a61298a47a40f;

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("2ixko", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ac71d7218c06efe$var$_react = $1ac71d7218c06efe$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $1ac71d7218c06efe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ac71d7218c06efe$var$Executable16Icon = (props)=>/*#__PURE__*/ $1ac71d7218c06efe$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$1ac71d7218c06efe$var$Executable16Icon.displayName = 'Executable16Icon';
var $1ac71d7218c06efe$var$_default = module.exports.default = $1ac71d7218c06efe$var$Executable16Icon;

});

parcelRegister("4dLYc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $312d962237f997a8$var$_react = $312d962237f997a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $312d962237f997a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $312d962237f997a8$var$Executable24Icon = (props)=>/*#__PURE__*/ $312d962237f997a8$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$312d962237f997a8$var$Executable24Icon.displayName = 'Executable24Icon';
var $312d962237f997a8$var$_default = module.exports.default = $312d962237f997a8$var$Executable24Icon;

});

parcelRegister("d5BUD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $987926a28539ecdc$var$_react = $987926a28539ecdc$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $987926a28539ecdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $987926a28539ecdc$var$Gif16Icon = (props)=>/*#__PURE__*/ $987926a28539ecdc$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$987926a28539ecdc$var$Gif16Icon.displayName = 'Gif16Icon';
var $987926a28539ecdc$var$_default = module.exports.default = $987926a28539ecdc$var$Gif16Icon;

});

parcelRegister("b4DX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $80ff0f2ee8339e7f$var$_react = $80ff0f2ee8339e7f$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $80ff0f2ee8339e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80ff0f2ee8339e7f$var$Gif24Icon = (props)=>/*#__PURE__*/ $80ff0f2ee8339e7f$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$80ff0f2ee8339e7f$var$Gif24Icon.displayName = 'Gif24Icon';
var $80ff0f2ee8339e7f$var$_default = module.exports.default = $80ff0f2ee8339e7f$var$Gif24Icon;

});

parcelRegister("4rkAw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $33b9a76c1d425a4b$var$_react = $33b9a76c1d425a4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $33b9a76c1d425a4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33b9a76c1d425a4b$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $33b9a76c1d425a4b$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$33b9a76c1d425a4b$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $33b9a76c1d425a4b$var$_default = module.exports.default = $33b9a76c1d425a4b$var$GoogleDoc16Icon;

});

parcelRegister("5W6v1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $45276929af089f1e$var$_react = $45276929af089f1e$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $45276929af089f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45276929af089f1e$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $45276929af089f1e$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$45276929af089f1e$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $45276929af089f1e$var$_default = module.exports.default = $45276929af089f1e$var$GoogleDoc24Icon;

});

parcelRegister("jDMpf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e4c73548be2d77b2$var$_react = $e4c73548be2d77b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $e4c73548be2d77b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4c73548be2d77b2$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $e4c73548be2d77b2$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e4c73548be2d77b2$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $e4c73548be2d77b2$var$_default = module.exports.default = $e4c73548be2d77b2$var$GoogleForm16Icon;

});

parcelRegister("av4P2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a508a3974c868b6$var$_react = $7a508a3974c868b6$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $7a508a3974c868b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a508a3974c868b6$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $7a508a3974c868b6$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7a508a3974c868b6$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $7a508a3974c868b6$var$_default = module.exports.default = $7a508a3974c868b6$var$GoogleForm24Icon;

});

parcelRegister("l59oX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f5915b8e34e2cce4$var$_react = $f5915b8e34e2cce4$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $f5915b8e34e2cce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5915b8e34e2cce4$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f5915b8e34e2cce4$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f5915b8e34e2cce4$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f5915b8e34e2cce4$var$_default = module.exports.default = $f5915b8e34e2cce4$var$GoogleSheet16Icon;

});

parcelRegister("giYeH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bded0d6c49d90549$var$_react = $bded0d6c49d90549$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $bded0d6c49d90549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bded0d6c49d90549$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $bded0d6c49d90549$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bded0d6c49d90549$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $bded0d6c49d90549$var$_default = module.exports.default = $bded0d6c49d90549$var$GoogleSheet24Icon;

});

parcelRegister("jOGxt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6d3af3126d12bf0$var$_react = $e6d3af3126d12bf0$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $e6d3af3126d12bf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6d3af3126d12bf0$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $e6d3af3126d12bf0$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6d3af3126d12bf0$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $e6d3af3126d12bf0$var$_default = module.exports.default = $e6d3af3126d12bf0$var$GoogleSlide16Icon;

});

parcelRegister("eWLPt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ae1b9556e1933b44$var$_react = $ae1b9556e1933b44$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $ae1b9556e1933b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae1b9556e1933b44$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $ae1b9556e1933b44$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ae1b9556e1933b44$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $ae1b9556e1933b44$var$_default = module.exports.default = $ae1b9556e1933b44$var$GoogleSlide24Icon;

});

parcelRegister("d8Kpd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $991004eb95b782af$var$_react = $991004eb95b782af$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $991004eb95b782af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $991004eb95b782af$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $991004eb95b782af$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$991004eb95b782af$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $991004eb95b782af$var$_default = module.exports.default = $991004eb95b782af$var$ExcelSpreadsheet16Icon;

});

parcelRegister("gH8Rx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c277896da6578a99$var$_react = $c277896da6578a99$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $c277896da6578a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c277896da6578a99$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $c277896da6578a99$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c277896da6578a99$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $c277896da6578a99$var$_default = module.exports.default = $c277896da6578a99$var$ExcelSpreadsheet24Icon;

});

parcelRegister("hY1Uy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d14985c3ed2ec0ae$var$_react = $d14985c3ed2ec0ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $d14985c3ed2ec0ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $d14985c3ed2ec0ae$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d14985c3ed2ec0ae$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $d14985c3ed2ec0ae$var$_default = module.exports.default = $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon;

});

parcelRegister("dfQbH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a652876e1a65311$var$_react = $9a652876e1a65311$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $9a652876e1a65311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a652876e1a65311$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $9a652876e1a65311$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a652876e1a65311$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $9a652876e1a65311$var$_default = module.exports.default = $9a652876e1a65311$var$PowerpointPresentation24Icon;

});

parcelRegister("90Icb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68f6656ee3eec0b2$var$_react = $68f6656ee3eec0b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $68f6656ee3eec0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68f6656ee3eec0b2$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $68f6656ee3eec0b2$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$68f6656ee3eec0b2$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $68f6656ee3eec0b2$var$_default = module.exports.default = $68f6656ee3eec0b2$var$WordDocument16Icon;

});

parcelRegister("lkBga", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8785e41f79a32cd$var$_react = $f8785e41f79a32cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $f8785e41f79a32cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8785e41f79a32cd$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $f8785e41f79a32cd$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8785e41f79a32cd$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $f8785e41f79a32cd$var$_default = module.exports.default = $f8785e41f79a32cd$var$WordDocument24Icon;

});

parcelRegister("11LZV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0bfb1dce28d59ddd$var$_react = $0bfb1dce28d59ddd$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $0bfb1dce28d59ddd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bfb1dce28d59ddd$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $0bfb1dce28d59ddd$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$0bfb1dce28d59ddd$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $0bfb1dce28d59ddd$var$_default = module.exports.default = $0bfb1dce28d59ddd$var$PdfDocument16Icon;

});

parcelRegister("lzyQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fb47e6517d9f8e39$var$_react = $fb47e6517d9f8e39$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $fb47e6517d9f8e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb47e6517d9f8e39$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $fb47e6517d9f8e39$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fb47e6517d9f8e39$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $fb47e6517d9f8e39$var$_default = module.exports.default = $fb47e6517d9f8e39$var$PdfDocument24Icon;

});

parcelRegister("9W0IA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73ba16739a647a26$var$_react = $73ba16739a647a26$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $73ba16739a647a26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73ba16739a647a26$var$Sketch16Icon = (props)=>/*#__PURE__*/ $73ba16739a647a26$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$73ba16739a647a26$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $73ba16739a647a26$var$_default = module.exports.default = $73ba16739a647a26$var$Sketch16Icon;

});

parcelRegister("9AnKp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6fa9e5979f68da4f$var$_react = $6fa9e5979f68da4f$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $6fa9e5979f68da4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6fa9e5979f68da4f$var$Sketch24Icon = (props)=>/*#__PURE__*/ $6fa9e5979f68da4f$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6fa9e5979f68da4f$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $6fa9e5979f68da4f$var$_default = module.exports.default = $6fa9e5979f68da4f$var$Sketch24Icon;

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $009878891f6679eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

function $009878891f6679eb$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("gPNUg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1babd35f9918b35a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba2400aa1a21e98b14b3159dd611e30a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $fP78j = parcelRequire("fP78j");

function $1babd35f9918b35a$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("9Q0L0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4648df99867255b9e8ae22693a4d25a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $fP78j = parcelRequire("fP78j");

function $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
}

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4b99d5ed076c1160$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

function $4b99d5ed076c1160$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("5rEH7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $011790d80979173b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b52a9f186ad8e116ad7e1e0109b235a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $fP78j = parcelRequire("fP78j");

function $011790d80979173b$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef63a9b3b9aed96b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

function $ef63a9b3b9aed96b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("alMZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1b8a825273197b02$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b59d4caf81c32d029adf911a314af4f7>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $fP78j = parcelRequire("fP78j");

function $1b8a825273197b02$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("4ymXE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $350c2601c1bf73a9$var$_react = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("42omo")));

var $350c2601c1bf73a9$var$_baseNew = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $350c2601c1bf73a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $350c2601c1bf73a9$var$AiSearchIcon = (props)=>/*#__PURE__*/ $350c2601c1bf73a9$var$_react.default.createElement($350c2601c1bf73a9$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$350c2601c1bf73a9$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $350c2601c1bf73a9$var$_default = module.exports.default = $350c2601c1bf73a9$var$AiSearchIcon;

});

parcelRegister("h982G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $i25hX = parcelRequire("i25hX");

const $a5e138d08f3fc65b$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $a5e138d08f3fc65b$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $a5e138d08f3fc65b$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $a5e138d08f3fc65b$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $a5e138d08f3fc65b$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($a5e138d08f3fc65b$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $a5e138d08f3fc65b$var$allowedOrigins.includes(hostname));
};
const $a5e138d08f3fc65b$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $a5e138d08f3fc65b$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $a5e138d08f3fc65b$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, (0, $dh538.fg)('ai-mate-pub-sub-post-message-origin-fix') ? {
                        targetOrigin: '*'
                    } : undefined);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $a5e138d08f3fc65b$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $42omo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $a5e138d08f3fc65b$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $42omo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $a5e138d08f3fc65b$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["RovoPostMessagePubsubListener"] = $a5e138d08f3fc65b$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $a5e138d08f3fc65b$export$5340cc94dd0ecbea;

});

parcelRegister("gKlAz", function(module, exports) {

var $eG1Z0 = parcelRequire("eG1Z0");


var $aoDcQ = parcelRequire("aoDcQ");

function $ac303ab343815a94$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $aoDcQ.text)(maybeNode) : maybeNode;
    if ((0, $eG1Z0.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $eG1Z0.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $ac303ab343815a94$export$50d34f59d07755a2;

});

parcelRegister("eG1Z0", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9abe739d14fcbdba$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $9abe739d14fcbdba$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}
module.exports["isDuplicateMark"] = $9abe739d14fcbdba$export$5ec47a80d7cc0dfa;
module.exports["duplicateMarkError"] = $9abe739d14fcbdba$export$db1000b9ac08ce57;

});

parcelRegister("iJQnc", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $0c4bf63002e7b177$export$6565f9f03506010b = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $0c4bf63002e7b177$export$6565f9f03506010b;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("7t8Pn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $570216d1bcbf60e3$var$_react = $570216d1bcbf60e3$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $570216d1bcbf60e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $570216d1bcbf60e3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $570216d1bcbf60e3$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$570216d1bcbf60e3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $570216d1bcbf60e3$var$_default = module.exports.default = $570216d1bcbf60e3$var$SourceCode24Icon;

});


//# sourceMappingURL=cards-extension.38bb8480.js.map
